export default {
    en: {
        Tasks: 'Tasks',
        Users: 'Users',
        OwnTasks: 'Own tasks',
        AllTasks: 'All tasks',
        UnassignedTasks: 'Unassigned tasks',
        Clients: 'Clients',
        Groups: 'Groups',
        UserTypes: 'User types',
        Vehicles: 'Vehicles',
        WorkTypes: 'Work types',
        Transport: 'Transport',
        TransportTypes: 'Transport types',
        Projects: 'Projects',
        ClosedTasks: 'Closed tasks',
        Login: 'Login',
        LoginText: 'Welcome back, please login to your account.',
        Password: 'Password',
        RememberMe: 'Remember Me',
        ForgotPassword: 'Forgot Password?',
        TaskTitle: 'Title',
        Status: 'Status',
        Priority: 'Priority',
        Deadline: 'Deadline',
        Added: 'Added',
        AssignedUser: 'Assigned user',
        Client: 'Client',
        Description: 'Description',
        Edit: 'Edit',
        ClientData: 'Client data',
        Name: 'Name',
        Address: 'Address',
        Country: 'Country',
        AssignedUsers: 'Assigned users',
        Add: 'Add',
        Times: 'Times',
        Material: 'Material',
        Files: 'Files',
        Chat: 'Chat',
        User: 'User',
        StartTime: 'Start time',
        EndTime: 'End time',
        WorkType: 'Work type',
        TypeMessage: 'Type message',
        Notes: 'Notes',
        AddNotes: 'Add notes',
        EditTime: 'Edit time',
        Delete: 'Delete',
        Change: 'Change',
        Save: 'Save',
        StartPoint: 'Start point',
        EndPoint: 'End point',
        Vehicle: 'Vehicle',
        TransportType: 'Transport type',
        EditTransport: 'Edit transport',
        Distance: 'Distance',
        Unit: 'Unit',
        Quantity: 'Quantity',
        EditMaterial: 'Edit material',
        StartKilometers: 'Start kilometers',
        EndKilometers: 'End kilometers',
        StartWithWork: 'Start with work',
        StopWithWork: 'Stop with work',
        AdditionalNotes: 'Additional notes',
        TakeTask: 'Take task',
        Unassigned: 'Unassigned',
        Open: 'Open',
        InProgress: 'In progress',
        Waiting: 'Waiting',
        SentForConfirmation: 'Sent for confirmation',
        Confirmed: "Confirmed",
        Invoiced: "Invoiced",
        VATNumber: "VAT Number",
        Price: 'Price',
        Email: 'Email',
        PhoneNumber: 'Phone number',
        ContractHours: 'Contract hours',
        Type: 'Type',
        Registration: 'Registration',
        Roles: 'Roles',
        LName: 'Last name',
        Role: 'Role',
        UserType: 'User type',
        Data: 'Data',
        Theme: 'Theme',
        ChangeTheme: 'Change theme',
        Dark: 'Dark',
        Light: 'Light',
        ChangePassword: 'Change password',
        EnableTOTP: "Enable 2FA",
        AuthenticatorCode: "Code from 2FA application",
        TOTPEnabled: "2FA active",
        OldPass: 'Current password',
        NewPass: 'New password',
        HourNumber: 'Number of hours',
        VacationDays: 'Vacation days',
        PlannedAbsence: 'Planned absence',
        SickLeaves: 'Sick leave',
        SupportEquipment: 'Support equipment',
        Meter: 'Meter',
        Piece: 'Piece',
        GiveTask: 'Give task',
        GiveTaskText: 'Are you sure you want to give task to someone else?',
        Company: 'Company',
        Rejected: 'Rejected',
        UploadFile: 'Upload file',
        Size: 'Size',
        Download: 'Download',
        EditNotes: 'Edit notes',
        Comments: 'Comments',
        PauseWork: 'Pause work',
        ContinueWithWork: 'Continue with work',
        Project: 'Project',
        TotalTime: 'Total time',
        Resize: 'Resize',
        ProjectTemplates: 'Project templates',
        DeadlineFromStart: 'Deadline from start (days)',
        ProjectTemplateTasks: 'Project template tasks',
        Template: 'Template',
        Without: 'Without',
        TaskIsPaused: 'Task is paused',
        RemoveTime: 'Remove time',
        RemoveTimeText: 'Are you sure you want to remove this time?',
        Reason: 'Reason',
        Multiplier: 'Multiplier',
        ProjectHours: 'Project task hours',
        EditWorkType: 'Edit work type',
        EditInvoicing: 'Edit invoicing',
        Yes: 'Yes',
        No: 'No',
        NonInvoicedPart: 'Non invoiced part',
        NonInvoicedTime: 'Non invoiced time',
        InvoicingComment: 'Invoicing comment',
        SendToConfirm: 'Send to confirm',
        Contacts: 'Contacts',
        Preview: 'Preview',
        OpenPDF: 'Open',
        BranchOffice: 'Branch office',
        Contact: 'Contact',
        EditContact: 'Edit contact',
        AddContact: 'Add contact',
        TaskSentForConfirmation: 'Task sent for confirmation!',
        Approve: 'Approve',
        ApproveTask: 'Approve task',
        TaskApproved: 'Task successfully approved!',
        Decline: 'Decline',
        DeclineTask: 'Decline task',
        TaskDeclined: 'Task successfully declined!',
        OpenPrintout: 'Open PDF',
        PrimaryContact: 'Primary contact',
        BranchOffices: 'Branch offices',
        Title: 'Title',
        PostNumAddr: 'Town and zip code',
        Town: 'Town',
        StartWithTransport: 'Start with transport',
        Passengers: 'Passengers',
        Destination: 'Destination',
        FinishTransport: 'Finish transport',
        TransportHome: 'Transport home',
        List: 'List',
        Settings: 'Settings',
        Holidays: 'Holidays',
        Days: 'Days',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        Sunday: 'Sunday',
        BasicSettings: 'Basic settings',
        MinimalInvoicingUnit: 'Minimal invoicing unit (in minutes)',
        MinimalWorkTimePerDay: 'Minimal number of work hours per day',
        WorkDays: 'Work days',
        Timezone: 'Timezone',
        HeadquartersAddress: 'Headquarters address',
        Year: 'Year',
        Month: 'Month',
        Time: 'Time',
        RegenerateTimes: 'Regenerate times',
        TimesPerMonth: 'Times per month',
        TimesRegenerated: 'Times regenerated',
        Saved: 'Saved',
        Profile: 'Profile',
        Logout: 'Logout',
        TimeOverview: 'Time overview',
        FinishedHours: 'Hours finished',
        HoursNeeded: 'Hours needed',
        Total: 'Total',
        Absence: 'Absence',
        Work: 'Work',
        Analytics: 'Analytics',
        ResetPass: 'Reset password',
        SendResetMail: 'Send request',
        ResetText: 'Mail with link and instructions has been sent to you!',
        PasswordReset: 'Password was changed successfully',
        Reload: "Reload",
        MonthlyDifferenceTillNow: 'Monthly hour difference until now',
        TotalDifferenceTillNow: 'Total hour difference until now',
        AbsenceRequestsAdding: 'Absence request adding',
        AddAbsence: 'Add planned absence',
        AddVacation: 'Add vacation',
        AddSickLeave: 'Add sick leave',
        Statistics: 'Statistics',
        Vacations: 'Vacations',
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
        VacationsContract: 'Vacations contract',
        SickLeaveProofs: 'Sick notes',
        SickLeave: 'Sick leave',
        Vacation: 'Vacation',
        TimeLockDay: 'Time lock day',
        MonthlyDifference: 'Monthly difference',
        Invoicing: 'Invoicing',
        TasksWaiting: 'Tasks waiting',
        InvoicesFinished: 'Invoices finished',
        InvoicesWaiting: 'Invoices waiting',
        CreateInvoicingGroup: 'Create group',
        AddToInvoicingGroup: 'Add to group',
        NumberOfTasks: 'Number of tasks',
        Date: 'Date',
        TaskIds: 'Task IDs',
        RemoveInvoicingGroup: 'Remove group',
        DeniedLetter: 'D',
        DeniedReason: 'Denial reason:',
        Id: "ID",
        File: 'File',
        Requests: 'Requests',
        TransportNames: 'Transport names',
        Kilometers: 'Kilometers',
        CountKilometers: 'Count kilometers',
        AllowManualUse: 'Allow use in manual start',
        Difference: 'Difference',
        Finish: 'Finish',
        VacationLockDay: 'Past year vacation removal day',
        VacationLockMonth: 'Past year vacation removal month',
        Comment: 'Comment',
        Adder: 'Adder',
        TimeEdits: 'Manual time edits',
        TravelOrders: 'Travel orders',
        Day: 'Day',
        Driver: 'Driver',
        OpenTasks: 'Open tasks',
        ClientTimeOverview: 'Client time overview',
        LastKilometers: 'Last kilometers',
        GeneratePDF: 'Generate PDF',
        GenerateExcel: 'Generate Excel',
        ProjectOffers: 'Project offers',
        ProjectOfferTasks: 'Offer tasks',
        CreateProjectFromOffer: 'Create project from offer',
        SaveAsTemplate: 'Save as template',
        CreateProjectFromTemplate: 'Create project from template',
        CreateProjectOfferFromTemplate: 'Create project offer from template',
        Other: 'Other',
        Offer: 'Offer',
        Invoice: 'Invoice',
        Documentation: 'Documentation',
        Finished: 'Finished',
        FinishProjectWithoutHandover: 'Finish project without handover',
        StartWithHandover: 'Start with handover',
        ConfirmHandover: 'Confirm handover',
        HandoverDeclined: 'Handover successfully declined',
        HandoverApproved: 'Handover successfully approved',
        HandoverNotes: 'Notes',
        ApproveHandover: 'Approve handover',
        DeclineHandover: 'Decline handover',
        StopHandover: 'Stop handover',
        InvoicedProjects: 'Invoiced',
        FinishNoHandoverPrompt: 'Are you sure you want to finish project? Editing after this will no longer be possible!',
        ProjectFinished: 'Projekt finished',
        ProjectWaitingForUserConfirm: 'Waiting for project leader confirmation',
        ProjectWaitingForClientConfirm: 'Waiting for client confirmation',
        FileType: 'File type',
        OfferId: 'Offer ID',
        DownloadHandoverPrintout: 'Download handover printout',
        ProjectFinishedWithoutHandover: 'Project finished without handover!',
        Start: 'Start',
        AllProjects: 'All',
        OwnProjects: 'My',
        OpenProjects: 'Open',
        FinishedProjects: 'Finished',
        PausedTasks: 'Paused',
        Commercial: 'Commercial',
        Week: 'Week',
        Calendar: 'Calendar',
        Absences: 'Absences',
        CarryTimeOver: 'Carry time over to next month',
        IgnoreMultipliers: 'Ignore multipliers',
        ProjectLeader: 'Project leader',
        Overviews: 'Overviews',
        TimeWorked: 'Worked time',
        PlannedTime: 'Planned time',
        DateCreated: 'Date created',
        DateFinished: 'Date finished',
        Color: 'Color',
        Tag: 'Tag',
        Tags: 'Tags',
        GlobalTag: 'Global tag',
        SaveTags: 'Save tags',
        EditTags: 'Edit tags',
        Notifications: 'Notifications',
        SatisfactionWithUs: 'How satisfied are you with us?',
        DuplicateSelectedTransport: 'Duplicate selected transport',
        TravelOrderInvalid: 'Travel order is not valid!',
        OpenTravelOrder: 'Open',
        RegenerateTravelOrder: 'Regenerate travel order',
        BranchOfficeLocationValid: 'Location found',
        SetVisibleTags: 'Visible tags',
        ExpandColumns: 'Expand columns',
        ClearFilters: 'Clear filters',
        atVehicles: 'Special vehicles',
        PeriodsTable: 'Periods table',
        GenerationFailed: 'Generation failed',
        Refueled: 'Refueled',
        RefuelSize: 'Refuel size',
        WayPoints: 'Waypoints',
        StartGeneration: 'Start generation',
        ApprovalTime: 'Approved',
        BusinessTrips: 'Business trips',
        CoWorkers: 'Coworkers',
        NotificationStartHour: 'Notification start hour',
        NotificationEndHour: 'Notification end hour',
        DashTasksToday: 'Day',
        DashTasksThisWeek: 'Week',
        DashTasksThisMonth: 'Month',
        Dashboard: 'Dashboard',
        TasksAdded: 'Added',
        TasksFinished: 'Finished',
        DashTimeToday: 'Day',
        DashTimeThisWeek: 'Week',
        DashTimeThisMonth: 'Month',
        DashTimeInvoiced: 'Invoiced',
        DashTimeNonInvoiced: 'Non invoiced',
        DashTimeOnCompany: 'On company',
        DashTaskNum: 'All tasks by priority',
        DashTaskTime: 'Time by priority',
        DashTaskNumOwn: 'My tasks',
        DashOwnTasksOpen: 'Open',
        DashOwnTasksInConfirmation: 'In confirmation',
        DashOwnTasksDeadlineToday: 'Deadline today',
        DashOwnTasksDeadlineNext7Days: 'Deadline in nexy 7 days',
        DashOwnTasksOverDeadline: 'Over deadline',
        StealTask: 'Steal task',
        TimeAnalytics: 'Time analytics',
        OnlyProjects: 'Only projects',
        Untagged: 'Untagged',
        AnalyticsTotalTime: "Total time",
        AnalyticsNonInvoicedTime: 'Non invoiced time',
        TimeByUser: 'Time by user',
        TimeByClient: 'Time by client',
        OnCall: 'On Call',
        CandidateGeneration: 'Candidate generation',
        BranchOfficePlacement: 'Branch office placement',
        TravelOrderGeneration: 'Travel order generation',
        ChangeClient: 'Change client',
        Offers: 'Offers',
        MyOffers: 'Own',
        AllOffers: 'All',
        FinishedOffers: 'Finished',
        ArchivedOffers: 'Archived',
        OffersInMaking: 'In making',
        ApprovedOffers: 'Approved',
        OfferManagementUser: 'Offer manager',
        CommercialUser: 'Assigned commercialist',
        OffersAdded: 'Added',
        OffersChangeNeeded: 'Change needed',
        OffersReadyForMaking: 'Ready for making',
        OffersTaken: 'Taken',
        OffersInWork: 'In work',
        OffersOfferMade: 'Offer made',
        OffersSentToClient: 'Sent to client',
        OffersApproved: 'Approved',
        OffersOrdered: 'Ordered',
        OffersFinished: 'Finished',
        OffersArchived: 'Archived',
        UploadOffer: 'Upload offer',
        UnsavedChanges: 'You have unsaved changes',
        OfferCommercialNotes: 'Commercial notes',
        AddOfferCommercialNotes: 'Add commercial notes',
        CancelOffer: 'Cancel offer',
        TakeOffer: 'Take offer',
        FinishOffer: 'Finish offer',
        OfferType: 'Offer type',
        OfferNormal: 'Without project',
        AddBackToOffers: 'Add back to offers',
        DateAdded: 'Date added',
        LastChange: 'Last change',
        Meetings: 'Meetings',
        MyMeetings: 'My',
        PlannedMeetings: 'Planned',
        FinishedMeetings: 'Finished',
        OpenTask: 'Open task',
        OpenOffer: 'Open offer',
        OfferTimelineShort0: 'Preparing',
        OfferTimelineLong0: 'Offer request is being prepared',
        OfferTimelineShort1: 'Change needed',
        OfferTimelineLong1: 'A change in offer was requested',
        OfferTimelineShort2: 'Request ready',
        OfferTimelineLong2: 'Offer request is ready and waiting to be taken by commercialist',
        OfferTimelineShort3: 'Request taken',
        OfferTimelineLong3: 'Offer request was taken by commercialist',
        OfferTimelineShort4: 'In making',
        OfferTimelineLong4: 'Offer is being made',
        OfferTimelineShort5: 'Offer ready',
        OfferTimelineLong5: 'The requested offer is finished',
        OfferTimelineShort6: 'Sent to client',
        OfferTimelineLong6: 'Offer was sent to client.',
        OfferTimelineShort7: 'Approved',
        OfferTimelineLong7: 'Client approved the offer',
        OfferTimelineShort8: 'Ordered',
        OfferTimelineLong8: 'Material from offer was ordered',
        OfferTimelineShort9: 'Finished',
        OfferTimelineLong9: 'Offer is finished',
        OfferTimelineShort10: 'Declined',
        OfferTimelineLong10: 'Offer was declined',
        OfferTimeline: 'Offer timeline',
        ApproveMeeting: 'Approve',
        MeetingApproved: 'Your approval was successful!',
        DeclineMeeting: 'Decline',
        MeetingDeclined: 'Meeting notes were successfully declined!',
        MeetingConfirmed: 'Meeting confirmed',
        OpenMeetingPrintout: 'Open printout',
        Services: 'Services',
        KnowledgeBase: 'Knowledge Base',
        DaysLeft: 'Days left',
        ParentalLeaves: 'Parental leaves',
        AddParentalLeave: 'Add parental leave',
        ParentalLeave: 'Parental leave',
        RegistrationTerminals: 'Registration terminals',
        LinkCopied: 'Link copied to clipboard',
        RFIDErrSelectionOpen: 'Selection is open! Close it before scanning a chip',
        RegistrationTerminalPIN: 'Registration terminal PIN',
        RegistrationTerminalRFIDId: 'Registration terminal RFID ID',
        Cancel: 'Cancel',
        TerminalEnter: 'Enter',
        TerminalPause: 'Pause',
        TerminalLeave: 'Leave',
        TerminalEnterSuccessful: 'Enter successful',
        TerminalEnterFailed: 'Enter Failed',
        TerminalPauseSuccessful: 'Pause successful',
        TerminalPauseFailed: 'Pause Failed',
        TerminalLeaveSuccessful: 'Leave successful',
        TerminalLeaveFailed: 'Leave Failed',
        RegistrationTerminalTask: 'This task was generated and is managed by registration terminal',
        RegistrationTerminalClient: 'Registration terminal client',
        RegistrationTerminalBranchOffice: 'Registration terminal branch office',
        RegistrationTerminalWorkType: 'Registration terminal work type',
        CommercialWiki: 'Commercial wiki',
        BoardWiki: 'Board wiki',
        MeetingsWiki: 'Meetings',
        ISOWiki: 'ISO',
        Active: 'Active',
        Passkeys: 'Passkeys'
    },
    sl:{
        Tasks: 'Delovni nalogi',
        Users: 'Uporabniki',
        OwnTasks: 'Moji',
        AllTasks: 'Vsi',
        UnassignedTasks: 'Nedodeljeni',
        Clients: 'Stranke',
        Groups: 'Skupine',
        UserTypes: 'Tipi uporabnikov',
        Vehicles: 'Vozila',
        WorkTypes: 'Šifranti storitev',
        Transport: 'Poti',
        TransportTypes: 'Tipi poti',
        Projects: 'Projekti',
        ClosedTasks: 'Zaključeni',
        Login: 'Prijava',
        LoginText: 'Dobrodošel nazaj, prijavi se v svoj račun.',
        Password: 'Geslo',
        RememberMe: 'Zapomni si me',
        ForgotPassword: 'Pozabljeno geslo?',
        TaskTitle: 'Naslov',
        Status: 'Stanje',
        Priority: 'Prioriteta',
        Deadline: 'Rok',
        Added: 'Dodano',
        AssignedUser: 'Dodeljen',
        Client: 'Stranka',
        Description: 'Opis',
        Edit: 'Uredi',
        ClientData: 'Podatki o stranki',
        Name: 'Ime',
        Address: 'Naslov',
        Country: 'Država',
        AssignedUsers: 'Dodeljeni',
        Add: 'Dodaj',
        Times: 'Časi',
        Material: 'Material',
        Files: 'Datoteke',
        Chat: 'Pogovor',
        User: 'Uporabnik',
        StartTime: 'Začetni čas',
        EndTime: 'Končni čas',
        WorkType: 'Tip dela',
        TypeMessage: 'Napiši sporočilo',
        Notes: 'Zapiski',
        AddNotes: 'Dodaj zapisek',
        EditTime: 'Uredi čas',
        Delete: 'Izbriši',
        Change: 'Spremeni',
        Save: 'Shrani',
        StartPoint: 'Začetna točka',
        EndPoint: 'Končna točka',
        Vehicle: 'Vozilo',
        TransportType: 'Tip poti',
        EditTransport: 'Uredi pot',
        Distance: 'Razdalja',
        Unit: 'Enota',
        Quantity: 'Količina',
        EditMaterial: 'Uredi material',
        StartKilometers: 'Začetni kilometri',
        EndKilometers: 'Končni kilometri',
        StartWithWork: 'Začni z delom',
        StopWithWork: 'Končaj z delom',
        AdditionalNotes: 'Dodatni zapiski',
        TakeTask: 'Prevzemi nalogo',
        Unassigned: 'Nedodeljen',
        Open: 'Dodeljen',
        InProgress: 'V delu',
        Waiting: 'Na čakanju',
        SentForConfirmation: 'V potrjevanju',
        Confirmed: "Potrjen",
        Invoiced: "Fakturiran",
        VATNumber: "Davčna številka",
        Price: 'Cena',
        Email: 'Email',
        PhoneNumber: 'Telefonska številka',
        ContractHours: 'Pogodbene ure',
        Type: 'Tip',
        Registration: 'Registracija',
        Roles: 'Skupine uporabnikov',
        LName: 'Priimek',
        Role: 'Vloga',
        UserType: 'Tip uporabnika',
        Data: 'Podatki',
        Theme: 'Tema',
        ChangeTheme: 'Zamenjaj temo',
        Dark: 'Temna',
        Light: 'Svetla',
        ChangePassword: 'Zamenjaj geslo',
        EnableTOTP: "Vključi 2FA",
        AuthenticatorCode: "Koda iz 2FA aplikacije",
        TOTPEnabled: "2FA aktiven",
        OldPass: 'Trenutno geslo',
        NewPass: 'Novo geslo',
        HourNumber: 'Število ur',
        VacationDays: 'Dopust',
        SickLeaves: 'Bolniške',
        PlannedAbsence: 'Napovedana odsotnost',
        SupportEquipment: 'Podporna oprema',
        Meter: 'Meter',
        Piece: 'kos',
        GiveTask: 'Dodeli nalogo',
        GiveTaskText: 'Ali si prepričan da želiš dodelit nalogo nekomu drugemu?',
        Company: 'Podjetje',
        Rejected: 'Zavrnjen',
        UploadFile: 'Naloži datoteko',
        Size: 'Veličina',
        Download: 'Prenesi',
        EditNotes: 'Uredi zapiske',
        Comments: 'Komentarji',
        PauseWork: 'Začasno ustavi',
        ContinueWithWork: 'Nadaljuj z delom',
        Project: 'Projekt',
        TotalTime: 'Skupni čas',
        Resize: 'Razširi',
        ProjectTemplates: 'Predloge za projekte',
        DeadlineFromStart: 'Rok od začetka (dnevi)',
        ProjectTemplateTasks: 'Naloge predloge',
        Template: 'Predloga',
        Without: 'Brez',
        TaskIsPaused: 'Naloga je na čakanju',
        RemoveTime: 'Izbriši čas',
        RemoveTimeText: 'Ali si prepričan da želiš izbrisat ta čas?',
        Reason: 'Razlog',
        Multiplier: 'Faktor',
        ProjectHours: 'Projektne ure naloge: ',
        EditWorkType: 'Uredi tip dela',
        EditInvoicing: 'Uredi fakturiranje',
        Yes: 'Da',
        No: 'Ne',
        NonInvoicedPart: 'Nefakturiran del',
        NonInvoicedTime: 'Nefakturiran čas (v urah)',
        InvoicingComment: 'Komentar za fakturiranje',
        SendToConfirm: 'Pošlji v potrjevanje',
        Contacts: 'Kontakti',
        Preview: 'Predogled',
        OpenPDF: 'Odpri',
        BranchOffice: 'Poslovalnica',
        Contact: 'Kontaktna oseba',
        EditContact: 'Spremeni kontaktno osebo',
        AddContact: 'Izberi kontaktno osebo',
        TaskSentForConfirmation: 'Nalog poslan v potrjevanje!',
        Approve: 'Potrdi',
        ApproveTask: 'Potrdi nalog',
        TaskApproved: 'Nalog je uspešno potrjen!',
        Decline: 'Zavrni',
        DeclineTask: 'Zavrni nalog',
        TaskDeclined: 'Nalog je uspešno zavrnjen!',
        OpenPrintout: 'Odpri nalog',
        PrimaryContact: 'Primarni kontakt',
        BranchOffices: 'Poslovalnice',
        Title: 'Naziv',
        PostNumAddr: 'Poštna številka in kraj',
        Town: 'Mesto',
        StartWithTransport: 'Začni z potjo',
        Passengers: 'Potniki',
        Destination: 'Destinacija',
        FinishTransport: 'Končaj pot',
        TransportHome: 'Pot domov',
        List: 'Seznam',
        Settings: 'Nastavitve',
        Holidays: 'Prazniki',
        Days: 'Dnevi',
        Monday: 'Ponedeljek',
        Tuesday: 'Torek',
        Wednesday: 'Sreda',
        Thursday: 'Četrtek',
        Friday: 'Petek',
        Saturday: 'Sobota',
        Sunday: 'Nedelja',
        BasicSettings: 'Osnovne nastavitve',
        MinimalInvoicingUnit: 'Minimalna obračunska enota (v minutah)',
        MinimalWorkTimePerDay: 'Minimalno število delovnih ur na dan',
        WorkDays: 'Delovni dnevi',
        Timezone: 'Časovni pas',
        HeadquartersAddress: 'Naslov sedeža podjetja',
        Year: 'Leto',
        Month: 'Mesec',
        Time: 'Čas',
        RegenerateTimes: 'Ponovno generiraj čase',
        TimesPerMonth: 'Potrebne oddelane ure po mescu',
        TimesRegenerated: 'Časi ponovno generirani',
        Saved: 'Shranjeno',
        Profile: 'Profil',
        Logout: 'Odjava',
        TimeOverview: 'Pregled časa v tekočem mescu',
        FinishedHours: 'Oddelane ure v tekočem mesecu',
        HoursNeeded: 'Potrebne ure v tekočem mesecu',
        Total: 'Skupaj',
        Absence: 'Odsotnost',
        Work: 'Delo',
        Analytics: 'Analitika',
        ResetPass: 'Spremeni geslo',
        SendResetMail: 'Pošlji zahtevo',
        ResetText: 'Mail z povezavo za spremembo gesla in navodili je bil poslan!',
        PasswordReset: 'Geslo je bilo uspešno spremenjeno',
        Reload: "Osveži",
        MonthlyDifferenceTillNow: 'Mesečna razlika ur do sedaj',
        TotalDifferenceTillNow: 'Skupna razlika ur do sedaj',
        AbsenceRequestsAdding: 'Zahtevki za odsotnost',
        AddAbsence: 'Napovedana odsotnost',
        AddVacation: 'Dopust',
        AddSickLeave: 'Bolniška',
        Statistics: 'Statistika',
        Vacations: 'Dopusti',
        January: 'Januar',
        February: 'Februar',
        March: 'Marec',
        April: 'April',
        May: 'Maj',
        June: 'Junij',
        July: 'Julij',
        August: 'Avgust',
        September: 'September',
        October: 'Oktober',
        November: 'November',
        December: 'December',
        VacationsContract: 'Odločba o dopustu',
        SickLeaveProofs: 'Bolniški listi',
        SickLeave: 'Bolniška',
        Vacation: 'Dopust',
        TimeLockDay: 'Dan zaklepa časa',
        MonthlyDifference: 'Mesečna razlika',
        Invoicing: 'Fakturiranje',
        TasksWaiting: 'Nalogi na čakanju',
        InvoicesFinished: 'Zaključene fakture',
        InvoicesWaiting: 'Fakture na čakanju',
        CreateInvoicingGroup: 'Naredi skupino',
        AddToInvoicingGroup: 'Dodaj v skupino',
        NumberOfTasks: 'Število nalogov',
        Date: 'Datum',
        TaskIds: 'Številke nalogov',
        RemoveInvoicingGroup: 'Izbriši skupino',
        DeniedLetter: 'Z',
        DeniedReason: 'Razlog zavrnitve:',
        Id: "ID",
        File: 'Datoteka',
        Requests: 'Zahtevki',
        TransportNames: 'Imena poti',
        Kilometers: 'Kilometri',
        CountKilometers: 'Upoštevaj kilometre',
        AllowManualUse: 'Dovoli uporabo',
        Difference: 'Razlika',
        Finish: 'Zaključi',
        VacationLockDay: 'Dan izbrisa lanskih dopustov',
        VacationLockMonth: 'Mesec izbrisa lanskih dopustov',
        Comment: 'Komentar',
        Adder: 'Dodal',
        TimeEdits: 'Ročne spremembe časa',
        TravelOrders: 'Potni nalogi',
        Day: 'Dan',
        Driver: 'Voznik',
        OpenTasks: 'Nalogi v delu',
        ClientTimeOverview: 'Pregled po stranki',
        DifferenceWorked: 'Razlika oddelanih ur',
        ConfirmedHours: 'Potrjene ure',
        DifferenceConfirmed: 'Razlika potrjenih ur',
        LastKilometers: 'Zadnji kilometri',
        GeneratePDF: 'Generiraj PDF',
        GenerateExcel: 'Generiraj Excel',
        ProjectOffers: 'Priprava projekta',
        ProjectOfferTasks: 'Naloge ponudbe',
        CreateProjectFromOffer: 'Naredi projekt iz ponudbe',
        SaveAsTemplate: 'Shrani kot predlogo',
        CreateProjectFromTemplate: 'Naredi projekt iz predloge',
        CreateProjectOfferFromTemplate: 'Naredi ponudbo iz predloge',
        Other: 'Ostalo',
        Offer: 'Ponudba',
        Invoice: 'Račun',
        Documentation: 'Dokumentacija',
        Finished: 'Zaključeno',
        FinishProjectWithoutHandover: 'Zaključi projekt brez primopredaje',
        StartWithHandover: 'Začni z primopredajo',
        ConfirmHandover: 'Potrdi primopredajni zapisnik',
        HandoverDeclined: 'Zapisnik uspešno zavrnjen',
        HandoverApproved: 'Zapisnik uspešno potrjen',
        HandoverNotes: 'Opombe',
        ApproveHandover: 'Potrdi primopredajni zapisnik',
        DeclineHandover: 'Zavrni primopredajni zapisnik',
        StopHandover: 'Ustavi primopredajo',
        InvoicedProjects: 'Fakturirani',
        FinishNoHandoverPrompt: 'Ali ste prepričani da želite zaključit project? Urejanje projekta ne bo več mogoče!',
        ProjectFinished: 'Projekt zaključen',
        ProjectWaitingForUserConfirm: 'Čakanje na potrditev nosilca projekta',
        ProjectWaitingForClientConfirm: 'Čakanje na potrditev stranke',
        FileType: 'Tip datoteke',
        OfferId: 'ID Ponudbe',
        DownloadHandoverPrintout: 'Primopredajni zapisnik',
        ProjectFinishedWithoutHandover: 'Projekt zaključen brez primopredaje!',
        Start: 'Začni',
        AllProjects: 'Vsi',
        OwnProjects: 'Moji',
        OpenProjects: 'Odprti',
        FinishedProjects: 'Zaključeni',
        PausedTasks: 'Na pavzi',
        Commercial: 'Komerciala',
        Week: 'Teden',
        Calendar: 'Koledar',
        Absences: 'Odsotnosti',
        CarryTimeOver: 'Prenesi ure v naslednji mesec',
        IgnoreMultipliers: 'Ignoriraj faktorje',
        ProjectLeader: 'Vodja projekta',
        Overviews: 'Pregledi',
        TimeWorked: 'Oddelan čas',
        PlannedTime: 'Predviden čas',
        DateCreated: 'Dodano',
        DateFinished: 'Zaključeno',
        Color: 'Barva',
        Tag: 'Oznaka',
        Tags: 'Oznake',
        GlobalTag: 'Globalna oznaka',
        SaveTags: 'Shrani oznake',
        EditTags: 'Uredi oznake',
        Notifications: 'Obvestila',
        SatisfactionWithUs: 'Kako zadovoljni ste z nami?',
        DuplicateSelectedTransport: 'Podvoji izbrano pot',
        TravelOrderInvalid: 'Potni nalog ni veljaven!',
        OpenTravelOrder: 'Odpri',
        RegenerateTravelOrder: 'Ponovno generiraj potni nalog',
        BranchOfficeLocationValid: 'Lokacija najdena',
        SetVisibleTags: 'Prikazane oznake',
        ExpandColumns: 'Razširi stolpce',
        ClearFilters: 'Počisti filtre',
        atVehicles: 'Posebna vozila',
        PeriodsTable: 'Tabela obdobij',
        GenerationFailed: 'Generiranje neuspešno',
        Refueled: 'Tankanje',
        RefuelSize: 'Količina goriva',
        WayPoints: 'Točke na poti',
        StartGeneration: 'Zaženi generiranje',
        ApprovalTime: 'Potrjen',
        BusinessTrips: 'Službene poti',
        CoWorkers: 'Sodelavci',
        NotificationStartHour: 'Začetek obvestil (v urah)',
        NotificationEndHour: 'Konec obvestil (v urah)',
        DashTasksToday: 'Dan',
        DashTasksThisWeek: 'Teden',
        DashTasksThisMonth: 'Mesec',
        Dashboard: 'Dashboard',
        TasksAdded: 'Dodani',
        TasksFinished: 'Zaključeni',
        DashTimeToday: 'Dan',
        DashTimeThisWeek: 'Teden',
        DashTimeThisMonth: 'Mesec',
        DashTimeInvoiced: 'Fakturirano',
        DashTimeNonInvoiced: 'Nefakturirano',
        DashTimeOnCompany: 'Na podjetje',
        DashTaskNum: 'Statistika vseh nalogov po prioriteti',
        DashTaskTime: 'Statistika časa po prioriteti',
        DashTaskNumOwn: 'Statistika mojih nalogov',
        DashOwnTasksOpen: 'Odprti',
        DashOwnTasksInConfirmation: 'V potrjevanju',
        DashOwnTasksDeadlineToday: 'Rok danes',
        DashOwnTasksDeadlineNext7Days: 'Rok naslednjih 7 dni',
        DashOwnTasksOverDeadline: 'Preko roka',
        StealTask: 'Vzemi nalog',
        TimeAnalytics: 'Analitika časa',
        OnlyProjects: 'Samo projekti',
        Untagged: 'Brez oznake',
        AnalyticsTotalTime: "Skupni čas",
        AnalyticsNonInvoicedTime: 'Nefakturiran čas',
        TimeByUser: 'Čas po uporabniku',
        TimeByClient: 'Čas po stranki',
        OnCall: 'Dežurstvo',
        CandidateGeneration: 'Kreiranje kandidatov',
        BranchOfficePlacement: 'Vstavljanje poslovalnic',
        TravelOrderGeneration: 'Kreiranje potnih nalogov',
        ChangeClient: 'Spremeni stranko',
        Offers: 'Ponudbe',
        MyOffers: 'Moje',
        AllOffers: 'Vse',
        FinishedOffers: 'Zaključene',
        ArchivedOffers: 'Arhivirane',
        OffersInMaking: 'V izdelavi',
        ApprovedOffers: 'Potrjene',
        OfferManagementUser: 'Skrbnik ponudbe',
        CommercialUser: 'Dodeljen komercialist',
        OffersAdded: 'Dodano',
        OffersChangeNeeded: 'Potrebna sprememba',
        OffersReadyForMaking: 'Pripravljeno na izdelavo',
        OffersTaken: 'Prevzeto',
        OffersInWork: 'V izdelavi',
        OffersOfferMade: 'Ponudba izdelana',
        OffersSentToClient: 'Poslano stranki',
        OffersApproved: 'Potrjena',
        OffersOrdered: 'Naročena',
        OffersFinished: 'Zaključena',
        OffersArchived: 'Arhivirana',
        UploadOffer: 'Naloži ponudbo',
        UnsavedChanges: 'Spremembe niso shranjene',
        OfferCommercialNotes: 'Komercialni zapiski',
        AddOfferCommercialNotes: 'Dodaj komercialne zapiske',
        CancelOffer: 'Prekliči ponudbo',
        TakeOffer: 'Prevzemi ponudbo',
        FinishOffer: 'Daj v izvedbo',
        OfferType: 'Tip ponudbe',
        OfferNormal: 'Brez projekta',
        AddBackToOffers: 'Dodaj nazaj med ponudbe',
        DateAdded: 'Dodano',
        LastChange: 'Zadnja sprememba',
        Meetings: 'Sestanki',
        MyMeetings: 'Moji',
        PlannedMeetings: 'Planirani',
        FinishedMeetings: 'Zaključeni',
        StartMeeting: 'Začni z sestankom',
        AddMeetingPoint: 'Dodaj točko sestanka',
        EndMeeting: 'Končaj sestanek',
        AddTask: 'Dodaj nalog',
        AddOffer: 'Dodaj ponudbo',
        RemovePoint: 'Odstrani točko',
        FinishMeeting: 'Zaključi sestanek',
        MeetingPlanned: 'Planiran',
        MeetingInProgress: 'V teku',
        MeetingStopped: 'Končan',
        MeetingFinished: 'Zaključen',
        OpenTask: 'Odpri nalog',
        OpenOffer: 'Odpri ponudbo',
        OfferTimelineShort0: 'Zahtevek v pripravi',
        OfferTimelineLong0: 'Zahtevek za ponudbo je v pripravi',
        OfferTimelineShort1: 'Potrebna sprememba',
        OfferTimelineLong1: 'Zahtevana je bila sprememba ponudbe',
        OfferTimelineShort2: 'Zahtevek pripravljen',
        OfferTimelineLong2: 'Zahtevek za ponudbo je pripravljen in čaka na prevzem s strani komercialista',
        OfferTimelineShort3: 'Zahtevek prevzet',
        OfferTimelineLong3: 'Zahtevek je bil prevzet s strani komercialista',
        OfferTimelineShort4: 'V izdelavi',
        OfferTimelineLong4: 'Zahtevek je v izdelavi',
        OfferTimelineShort5: 'Ponudba pripravljena',
        OfferTimelineLong5: 'Ponudba za zahtevek je bila izdelana',
        OfferTimelineShort6: 'Poslano stranki',
        OfferTimelineLong6: 'Ponudba je bil posredovana stranki in se čaka na odgovor',
        OfferTimelineShort7: 'Potrjena',
        OfferTimelineLong7: 'Stranka je ponudbo potrdila',
        OfferTimelineShort8: 'Naročeno',
        OfferTimelineLong8: 'Material iz ponudbe je bil naročen',
        OfferTimelineShort9: 'Zaključeno',
        OfferTimelineLong9: 'Ponudba je zaključena',
        OfferTimelineShort10: 'Zavrnjena',
        OfferTimelineLong10: 'Ponudba je bila zavrnjena',
        OfferTimeline: 'Časovnica ponudbe',
        ApproveMeeting: 'Potrdi zapisnik',
        MeetingApproved: 'Zapisnik je uspešno potrjen!',
        DeclineMeeting: 'Zavrni zapisnik',
        MeetingDeclined: 'Zapisnik je uspešno zavrnjen!',
        MeetingConfirmed: 'Sestanek potrjen',
        OpenMeetingPrintout: 'Odpri zapisnik',
        Services: 'Storitve',
        KnowledgeBase: 'Baza znanja',
        DaysLeft: 'Preostali dnevi',
        ParentalLeaves: 'Starševski dopusti',
        AddParentalLeave: 'Dodaj starševski dopust',
        ParentalLeave: 'Starševski dopust',
        RegistrationTerminals: 'Prijavne konzole',
        LinkCopied: 'Povezava kopirana',
        RFIDErrSelectionOpen: 'Izbira je odprta. Zaprite jo za nadaljno skeniranja',
        RegistrationTerminalPIN: 'PIN za prijavno konzolo',
        RegistrationTerminalRFIDId: 'RFID ID za prijavno konzolo',
        Cancel: 'Prekliči',
        TerminalEnter: 'Prihod',
        TerminalPause: 'Pavza',
        TerminalLeave: 'Odhod',
        TerminalEnterSuccessful: 'Prihod uspešen',
        TerminalEnterFailed: 'Prihod neuspešen',
        TerminalPauseSuccessful: 'Pavza uspešna',
        TerminalPauseFailed: 'Pavza neuspešna',
        TerminalLeaveSuccessful: 'Izhod uspešen',
        TerminalLeaveFailed: 'Izhod neuspešen',
        RegistrationTerminalTask: 'Ta nalog je bil generiran in ga tudi upravlja prijavna konzola',
        RegistrationTerminalClient: 'Stranka pri prijavni konzoli',
        RegistrationTerminalBranchOffice: 'Poslovalnica pri prijavni konzole',
        RegistrationTerminalWorkType: 'Tip dela pri prijavni konzoli',
        CommercialWiki: 'Komerciala wiki',
        BoardWiki: 'Board wiki',
        MeetingsWiki: 'Sestanki',
        ISOWiki: 'ISO',
        Active: 'Aktiven',
        Passkeys: 'Varnostni ključi'
    },
    fr: {
        Tasks: 'Tâches',
        Users: 'Utilisateurs',
        OwnTasks: 'Mes Tâches',
        AllTasks: 'Toutes les tâches',
        UnassignedTasks: 'Tâches non attribués',
        Clients: 'Clients',
        Groups: 'Groupes',
        UserTypes: 'Types d\'utilisateurs',
        Vehicles: 'Véhicules',
        WorkTypes: 'Type de travail',
        Transport: 'Transport',
        TransportTypes: 'Type de transport',
        Projects: 'Projets',
        ClosedTasks: 'tâches fermées',
        Login: 'S\'identifier',
        LoginText: 'Bienvenue à nouveau, veuillez vous connecter à votre compte.',
        Password: 'Mot de passe',
        RememberMe: 'Souviens-toi de moi',
        ForgotPassword: 'Mot de passe oublié?',
        TaskTitle: 'Titre',
        Status: 'Statut',
        Priority: 'Priorité',
        Deadline: 'Date limite',
        Added: 'Ajouté',
        AssignedUser: 'Utilisateur attribué',
        Client: 'Client',
        Description: 'La description',
        Edit: 'Éditer',
        ClientData: 'Informations client',
        Name: 'Nom',
        Address: 'Adresse',
        Country: 'Pays',
        AssignedUsers: 'Utilisateurs attribué',
        Add: 'Ajouter',
        Times: 'Fois',
        Material: 'Matériel',
        Files: 'Des dossiers',
        Chat: 'Bavarder',
        User: 'Utilisateur',
        StartTime: 'Heure de début',
        EndTime: 'Heure de fin',
        WorkType: 'Type de travail',
        TypeMessage: 'Taper un message',
        Notes: 'Remarques',
        AddNotes: 'Ajouter une note',
        EditTime: 'Modifier l\'heure',
        Delete: 'Supprimer',
        Change: 'Changement',
        Save: 'Enregistrer',
        StartPoint: 'Point de départ',
        EndPoint: 'Point final',
        Vehicle: 'Véhicule',
        TransportType: 'Type de transport',
        EditTransport: 'Modifier Transport',
        Distance: 'Distance',
        Unit: 'Unité',
        Quantity: 'Quantité',
        EditMaterial: 'Modifier le matériel',
        StartKilometers: 'Kilomètres de départ',
        EndKilometers: 'Kilomètres finaux',
        StartWithWork: 'Commencez avec le travail',
        StopWithWork: 'Arrêter avec le travail',
        AdditionalNotes: 'Notes complémentaires',
        TakeTask: 'Prendre la tâche',
        Unassigned: 'Non attribué',
        Open: 'Ouvert',
        InProgress: 'En cours',
        Waiting: 'Attendre',
        SentForConfirmation: 'Envoyé pour confirmation',
        Confirmed: "Confirmé",
        Invoiced: "Facturé",
        VATNumber: "Numéro de TVA",
        Price: 'Prix',
        Email: 'Email',
        PhoneNumber: 'Numéro de téléphone',
        ContractHours: 'Heures d\'ouverture',
        Type: 'Type',
        Registration: 'Enregistrement',
        Roles: 'Les rôles',
        LName: 'Nom de famille',
        Role: 'Rôle',
        UserType: 'Type d\'utilisateur',
        Data: 'Les données',
        Theme: 'Thème',
        ChangeTheme: 'Change le thèmee',
        Dark: 'Sombre',
        Light: 'Lumière',
        ChangePassword: 'Changer le mot de passe',
        EnableTOTP: 'Activer 2FA',
        AuthenticatorCode: "Code de l'application 2FA",
        TOTPEnabled: "2FA actif",
        OldPass: 'Mot de passe actuel',
        NewPass: 'Nouveau mot de passe',
        HourNumber: 'Nombre d\'heures',
        VacationDays: 'Congé',
        PlannedAbsence: 'Absence prévue',
        SickLeaves: 'Congé de maladie',
        SupportEquipment: 'Matériel de support',
        Meter: 'Mètre',
        Piece: 'Pièce',
        GiveTask: 'Donner une tâche',
        GiveTaskText: 'Êtes-vous sûr de vouloir confier une tâche à quelqu\'un d\'autre?',
        Company: 'Compagnie',
        Rejected: 'Rejeté',
        UploadFile: 'Téléverser un fichier',
        Size: 'Taille du fichier',
        Download: 'Télécharger',
        EditNotes: 'Modifier les notes',
        Comments: 'Commentaires',
        PauseWork: 'Suspendre le travail',
        ContinueWithWork: 'Poursuivre le travail',
        Project: 'Projet',
        TotalTime: 'Temps total',
        Resize: 'Redimensionner',
        ProjectTemplates: 'Modèles de projet',
        DeadlineFromStart: 'Date limite de début (jours)',
        ProjectTemplateTasks: 'Tâches du modèle de projet',
        Template: 'Modèle',
        Without: 'Sans pour autant',
        TaskIsPaused: 'La tâche est suspendue',
        RemoveTime: 'Supprimer le temps',
        RemoveTimeText: 'Voulez-vous vraiment supprimer cette fois?',
        Reason: 'Raison',
        Multiplier: 'Multiplicateur',
        ProjectHours: 'Heures de tâche du projet',
        EditWorkType: 'Modifier le type de travail',
        EditInvoicing: 'Modifier la facturation',
        Yes: 'Oui',
        No: 'Non',
        NonInvoicedPart: 'Partie non facturée',
        NonInvoicedTime: 'Temps non facturé',
        InvoicingComment: 'Commentaire de facturation',
        SendToConfirm: 'Envoyer pour confirmer',
        Contacts: 'Contacts',
        Preview: 'Aperçu',
        OpenPDF: 'Ouvert',
        BranchOffice: 'Succursale',
        Contact: 'Contact',
        EditContact: 'Modifier le contact',
        AddContact: 'Jjouter le contact',
        TaskSentForConfirmation: 'Tâche envoyée pour confirmation!',
        Approve: 'Approuver',
        ApproveTask: 'Approuver la tâche',
        TaskApproved: 'Tâche approuvée avec succès!',
        Decline: 'Déclin',
        DeclineTask: 'Refuser la tâche',
        TaskDeclined: 'Tâche refusée avec succès!',
        OpenPrintout: 'Ouvrir le pdf',
        PrimaryContact: 'Premier contact',
        BranchOffices: 'Succursales',
        Title: 'Titre',
        PostNumAddr: 'Ville et code postal',
        Town: 'Ville',
        StartWithTransport: 'Commencez avec le transport',
        Passengers: 'Les passagers',
        Destination: 'Destination',
        FinishTransport: 'Terminer le transport',
        TransportHome: 'Chemin du retour',
        List: 'Liste',
        Settings: 'Paramètres',
        Holidays: 'Vacances',
        Days: 'Journées',
        Monday: 'Lundi',
        Tuesday: 'Mardi',
        Wednesday: 'Mercredi',
        Thursday: 'Jeudi',
        Friday: 'Vendredi',
        Saturday: 'Samedi',
        Sunday: 'Dimanche',
        BasicSettings: 'Paramètres de base',
        MinimalInvoicingUnit: 'Unité de facturation minimale (en minutes)',
        MinimalWorkTimePerDay: 'Nombre minimal d\'heures de travail par jour',
        WorkDays: 'Jours ouvrés',
        Timezone: 'Fuseau horaire',
        HeadquartersAddress: 'Adresse du siège',
        Year: 'An',
        Month: 'Mois',
        Time: 'Temps',
        RegenerateTimes: 'Régénérer les temps',
        TimesPerMonth: 'Fois par mois',
        TimesRegenerated: 'Temps régénérés',
        Saved: 'Enregistré',
        Profile: 'Profil',
        Logout: 'Se déconnecter',
        TimeOverview: 'Aperçu du temps',
        FinishedHours: 'Heures terminées',
        HoursNeeded: 'Heures nécessaires',
        Total: 'Total',
        Absence: 'Absence',
        Work: 'Travail',
        Analytics: 'Analytique',
        ResetPass: 'Réinitialiser le mot de passe',
        SendResetMail: 'Envoyer une demande',
        ResetText: 'Un mail avec lien et instructions vous a été envoyé!',
        PasswordReset: 'Le mot de passe a été changé avec succès',
        Reload: "Recharger",
        MonthlyDifferenceTillNow: 'Différence horaire mensuelle jusqu\'à présent',
        TotalDifferenceTillNow: 'Différence horaire totale jusqu\'à présent',
        AbsenceRequestsAdding: 'Ajout d\'une demande d\'absence',
        AddAbsence: 'Ajouter une absence planifiée',
        AddVacation: 'Ajouter des vacances',
        AddSickLeave: 'Ajouter un congé de maladie',
        Statistics: 'Statistiques',
        Vacations: 'Les vacances',
        January: 'Janvier',
        February: 'Février',
        March: 'Mars',
        April: 'Avril',
        May: 'Mai',
        June: 'Juin',
        July: 'Juillet',
        August: 'Août',
        September: 'Septembere',
        October: 'Octobre',
        November: 'Novembre',
        December: 'Décembre',
        VacationsContract: 'Contrat de vacances',
        SickLeaveProofs: 'Notes de maladie',
        SickLeave: 'Congé de maladie',
        Vacation: 'Vacances',
        TimeLockDay: 'Jour de verrouillage horaire',
        MonthlyDifference: 'Différence mensuelle',
        Invoicing: 'Facturation',
        TasksWaiting: 'Tâches en attente',
        InvoicesFinished: 'Factures terminées',
        InvoicesWaiting: 'Factures en attente',
        CreateInvoicingGroup: 'Créer un groupe',
        AddToInvoicingGroup: 'Ajouter au groupe',
        NumberOfTasks: 'Nombre de tâches',
        Date: 'Date',
        TaskIds: 'ID de tâche',
        RemoveInvoicingGroup: 'Supprimer le groupe',
        DeniedLetter: 'D',
        DeniedReason: 'Raison du refus:',
        Id: "ID",
        File: 'Fichier',
        Requests: 'Demandes',
        TransportNames: 'Noms de transport',
        Kilometers: 'Kilomètres',
        CountKilometers: 'Comptez les kilomètres',
        AllowManualUse: 'Autoriser l\'utilisation en démarrage manuel',
        Difference: 'Différence',
        Finish: 'Terminer',
        VacationLockDay: 'Jour de retrait des vacances de l\'année dernière',
        VacationLockMonth: 'Mois de retrait des vacances de l\'année précédente',
        Comment: 'Commentaire',
        Adder: 'Additionneur',
        TimeEdits: 'Modifications manuelles de l\'heure',
        TravelOrders: 'Ordres de voyage',
        Day: 'Journée',
        Driver: 'Chauffeur',
        OpenTasks: 'Tâches ouvertes',
        ClientTimeOverview: 'Aperçu de l\'heure du client',
        LastKilometers: 'Derniers kilomètres',
        GeneratePDF: 'Générer un PDF',
        GenerateExcel: 'Générer un Excel',
        ProjectOffers: 'Offres de projets',
        ProjectOfferTasks: 'Offrir des tâches',
        CreateProjectFromOffer: 'Créer un projet à partir de l\'offre',
        SaveAsTemplate: 'Enregistrer en tant que modèle',
        CreateProjectFromTemplate: 'Créer un projet à partir d\'un modèle',
        CreateProjectOfferFromTemplate: 'Créer une offre de projet à partir d\'un modèle',
        Other: 'Autre',
        Offer: 'Offre',
        Invoice: 'Facture d\'achat',
        Documentation: 'Documentation',
        Finished: 'Fini',
        FinishProjectWithoutHandover: 'Terminer le projet sans transfert',
        StartWithHandover: 'Commencez par le transfert',
        ConfirmHandover: 'Confirmer le transfert',
        HandoverDeclined: 'Le transfert a été refusé avec succès',
        HandoverApproved: 'Transfert approuvé avec succès',
        HandoverNotes: 'Remarques',
        ApproveHandover: 'Approuver le transfert',
        DeclineHandover: 'Refuser le transfert',
        StopHandover: 'Arrêter le transfert',
        InvoicedProjects: 'Facturé',
        FinishNoHandoverPrompt: 'Voulez-vous vraiment terminer le projet? Une modification après cela ne sera plus possible!',
        ProjectFinished: 'Projekt terminé',
        ProjectWaitingForUserConfirm: 'En attente de la confirmation du chef de projet',
        ProjectWaitingForClientConfirm: 'En attente de la confirmation du client',
        FileType: 'Type de fichier',
        OfferId: 'ID de l\'offre',
        DownloadHandoverPrintout: 'Télécharger l\'impression du transfert',
        ProjectFinishedWithoutHandover: 'Projet terminé sans transfert!',
        Start: 'Début',
        AllProjects: 'Tout',
        OwnProjects: 'Mon',
        OpenProjects: 'Ouvert',
        FinishedProjects: 'Fini',
        PausedTasks: 'En pause',
        Commercial: 'Commercial',
        Week: 'La semaine',
        Calendar: 'Calendrier',
        Absences: 'Absences',
        CarryTimeOver: 'Reportez le temps jusqu\'au mois prochain',
        IgnoreMultipliers: 'Ignorer les multiplicateurs',
        ProjectLeader: 'Chef de projet',
        Overviews: 'Aperçus',
        TimeWorked: 'Temps travaillé',
        PlannedTime: 'Heure prévue',
        DateCreated: 'Date créée',
        DateFinished: 'Date terminée',
        Color: 'Couleur',
        Tag: 'Marque',
        Tags: 'Des marques',
        GlobalTag: 'Marque globale',
        SaveTags: 'Enregistrer les marques',
        EditTags: 'Changer les marques',
        Notifications: 'Notifications',
        SatisfactionWithUs: 'Êtes-vous satisfait de nous?',
        DuplicateSelectedTransport: 'Dupliquer le transport sélectionné',
        TravelOrderInvalid: 'L\'ordre de voyage n\'est pas valide!',
        OpenTravelOrder: 'Ouvert',
        RegenerateTravelOrder: 'Régénérer l\'ordre de voyage',
        BranchOfficeLocationValid: 'Lieu trouvé',
        SetVisibleTags: 'Marques visibles',
        ExpandColumns: 'Développer les colonnes',
        ClearFilters: 'Effacer les filtres',
        atVehicles: 'Véhicules spéciaux',
        PeriodsTable: 'Tableau des périodes',
        GenerationFailed: 'Échec de la génération',
        Refueled: 'Ravitaillé',
        RefuelSize: 'Taille de ravitaillement',
        WayPoints: 'Points le long du chemin',
        StartGeneration: 'Lancer la génération',
        ApprovalTime: 'Approuvé',
        BusinessTrips: 'Voyage d\'affaire',
        CoWorkers: 'Collègues de travail',
        NotificationStartHour: 'Heure de début de la notification',
        NotificationEndHour: 'Heure de fin de notification',
        DashTasksToday: 'Journée',
        DashTasksThisWeek: 'La semaine',
        DashTasksThisMonth: 'Mois',
        Dashboard: 'Tableau de bord',
        TasksAdded: 'Ajouté',
        TasksFinished: 'Fini',
        DashTimeToday: 'Journée',
        DashTimeThisWeek: 'La semaine',
        DashTimeThisMonth: 'Mois',
        DashTimeInvoiced: 'Facturé',
        DashTimeNonInvoiced: 'Non facturé',
        DashTimeOnCompany: 'En entreprise',
        DashTaskNum: 'Toutes les tâches par priorité',
        DashTaskTime: 'Temps par priorité',
        DashTaskNumOwn: 'Mes tâches',
        DashOwnTasksOpen: 'Ouvert',
        DashOwnTasksInConfirmation: 'En confirmation',
        DashOwnTasksDeadlineToday: 'Date limite aujourd\'hui',
        DashOwnTasksDeadlineNext7Days: 'Date limite dans les 7 prochains jours',
        DashOwnTasksOverDeadline: 'Dépassement du délai',
        StealTask: 'Voler la tâche',
        TimeAnalytics: 'Analyse du temps',
        OnlyProjects: 'Seuls les projets',
        Untagged: 'Non Marques',
        AnalyticsTotalTime: "Temps total",
        AnalyticsNonInvoicedTime: 'Temps non facturé',
        TimeByUser: 'Temps par utilisateur',
        TimeByClient: 'Temps par client',
        OnCall: 'De garde',
        CandidateGeneration: 'Génération de candidats',
        BranchOfficePlacement: 'Placement dans les succursales',
        TravelOrderGeneration: 'Génération d\'ordre de voyage',
        ChangeClient: 'Changer de client',
        Offers: 'Des offres',
        MyOffers: 'Posséder',
        AllOffers: 'Tout',
        FinishedOffers: 'Fini',
        ArchivedOffers: 'Archivé',
        OffersInMaking: 'En faisant',
        ApprovedOffers: 'Approuvé',
        OfferManagementUser: 'Gestionnaire d\'offres',
        CommercialUser: 'Commercial assigné',
        OffersAdded: 'Ajouté',
        OffersChangeNeeded: 'Changement nécessaire',
        OffersReadyForMaking: 'Prêt à faire',
        OffersTaken: 'Pris',
        OffersInWork: 'Au travail',
        OffersOfferMade: 'Offre faite',
        OffersSentToClient: 'Envoyé au client',
        OffersApproved: 'Approuvé',
        OffersOrdered: 'Commandé',
        OffersFinished: 'Fini',
        OffersArchived: 'Archivé',
        UploadOffer: 'Télécharger l\'offre',
        UnsavedChanges: 'Vous avez des changements non enregistrés',
        OfferCommercialNotes: 'Vous avez des changements non enregistrés',
        AddOfferCommercialNotes: 'Ajouter des notes commerciales',
        CancelOffer: 'Annuler l\'offre',
        TakeOffer: 'Faire une offre',
        FinishOffer: 'Terminer l\'offre',
        OfferType: 'Type d\'offre',
        OfferNormal: 'Sans projet',
        AddBackToOffers: 'Ajouter aux offres',
        DateAdded: 'Date ajoutée',
        LastChange: 'Dernier changement',
        Meetings: 'Réunions',
        MyMeetings: 'Mon',
        PlannedMeetings: 'Prévu',
        FinishedMeetings: 'Fini',
        OpenTask: 'Tâche ouverte',
        OpenOffer: 'Offre ouverte',
        OfferTimelineShort0: 'En train de préparer',
        OfferTimelineLong0: 'La demande d\'offre est en cours de préparation',
        OfferTimelineShort1: 'Changement nécessaire',
        OfferTimelineLong1: 'Un changement d\'offre a été demandé',
        OfferTimelineShort2: 'Demande prête',
        OfferTimelineLong2: 'La demande d\'offre est prête et attend d\'être prise par le commercial',
        OfferTimelineShort3: 'Demande prise',
        OfferTimelineLong3: 'La demande d\'offre a été prise par un commercial',
        OfferTimelineShort4: 'En faisant',
        OfferTimelineLong4: 'L\'offre est en cours',
        OfferTimelineShort5: 'Offre prête',
        OfferTimelineLong5: 'L\'offre demandée est terminée',
        OfferTimelineShort6: 'Envoyé au client',
        OfferTimelineLong6: 'L\'offre a été envoyée au client.',
        OfferTimelineShort7: 'Approuvé',
        OfferTimelineLong7: 'Le client a approuvé l\'offre',
        OfferTimelineShort8: 'Commandé',
        OfferTimelineLong8: 'Le matériel de l\'offre a été commandé',
        OfferTimelineShort9: 'Fini',
        OfferTimelineLong9: 'L\'offre est terminée',
        OfferTimelineShort10: 'Refusée',
        OfferTimelineLong10: 'L\'offre a été refusée',
        OfferTimeline: 'Chronologie de l\'offre',
        ApproveMeeting: 'Approuver',
        MeetingApproved: 'Votre approbation a réussi!',
        DeclineMeeting: 'Refusée',
        MeetingDeclined: 'Les notes de réunion ont été refusées avec succès!',
        MeetingConfirmed: 'Réunion confirmée',
        OpenMeetingPrintout: 'Impression ouverte',
        Services: 'Prestations de service',
        KnowledgeBase: 'Base de connaissances',
        DaysLeft: 'Jours restants',
        ISOWiki: 'ISO',
        Active: 'Actif'
    },
    de: {
        Tasks: 'Aufgaben',
        Users: 'Benützer',
        OwnTasks: 'Eigene Aufgaben',
        AllTasks: 'Alle Aufgaben',
        UnassignedTasks: 'Nicht zugewiesene Aufgaben',
        Clients: 'Kunden',
        Groups: 'Gruppen',
        UserTypes: 'Benutzertyp',
        Vehicles: 'Fahrzeuge',
        WorkTypes: 'Arbeitstypen',
        Transport: 'Transport',
        TransportTypes: 'Transportarten',
        Projects: 'Projekte',
        ClosedTasks: 'Geschlossene Aufgaben',
        Login: 'Anmeldung',
        LoginText: 'Willkommen zurück, bitte melden Sie sich in Ihrem Konto an.',
        Password: 'Kennwort',
        RememberMe: 'Erinnere dich an mich',
        ForgotPassword: 'Passwort vergessen?',
        TaskTitle: 'Titel',
        Status: 'Status',
        Priority: 'Priorität',
        Deadline: 'Endtermin',
        Added: 'Hinzugefügt',
        AssignedUser: 'Zugewiesener Benutzer',
        Client: 'Kunde',
        Description: 'Beschreibung',
        Edit: 'Bearbeiten',
        ClientData: 'Kundendaten',
        Name: 'Name',
        Address: 'Adresse',
        Country: 'Staat',
        AssignedUsers: 'Zugewiesene Benutzer',
        Add: 'Hinzufügen',
        Times: 'Zeit',
        Material: 'Material',
        Files: 'Dateien',
        Chat: 'Konversation',
        User: 'Benützer',
        StartTime: 'Startzeit',
        EndTime: 'Endzeit',
        WorkType: 'Arbeitstyp',
        TypeMessage: 'Nachricht eingeben',
        Notes: 'Anmerkungen',
        AddNotes: 'Anmerkungen hinzufügen',
        EditTime: 'Zeit bearbeiten',
        Delete: 'Löschen',
        Change: 'Veränderung',
        Save: 'Speichern',
        StartPoint: 'Startpunkt',
        EndPoint: 'Endpunkt',
        Vehicle: 'Fahrzeug',
        TransportType: 'Routentyp',
        EditTransport: 'Routentyp bearbeiten',
        Distance: 'Entfernung',
        Unit: 'Einheit',
        Quantity: 'Menge',
        EditMaterial: 'Material bearbeiten',
        StartKilometers: 'Start kilometer',
        EndKilometers: 'End kilometer',
        StartWithWork: 'Arbeitsbeginn',
        StopWithWork: 'Arbeitsende',
        AdditionalNotes: 'Zusätzliche Bemerkungen',
        TakeTask: 'Aufgabe übernehmen',
        Unassigned: 'Nicht zugewiesen',
        Open: 'Zugewiesen',
        InProgress: 'In Bearbeitung',
        Waiting: 'Warten',
        SentForConfirmation: 'Zur Bestätigung gesendet',
        Confirmed: "Bestätigt",
        Invoiced: "In Rechnung gestellt",
        VATNumber: "Umsatzsteuer-Identifikationsnummer",
        Price: 'Preis',
        Email: 'Email',
        PhoneNumber: 'Telefonnummer',
        ContractHours: 'Vertragszeiten',
        Type: 'Typ',
        Registration: 'Anmeldung',
        Roles: 'Benutzergruppen',
        LName: 'Nachname',
        Role: 'Rolle',
        UserType: 'Benutzertyp',
        Data: 'Daten',
        Theme: 'Thema',
        ChangeTheme: 'Thema ändern',
        Dark: 'Dunkel',
        Light: 'Hell',
        ChangePassword: 'Ändere das Kennwort',
        EnableTOTP: "2FA aktivieren",
        AuthenticatorCode: "Code aus der 2FA-App",
        TOTPEnabled: "2FA aktiv",
        OldPass: 'Derzeitiges Kennwort',
        NewPass: 'Neues Kennwort',
        HourNumber: 'Anzahl der Stunden',
        VacationDays: 'Ferientage',
        PlannedAbsence: 'Geplante Abwesenheit',
        SickLeaves: 'Krankenstand',
        SupportEquipment: 'Support-Ausrüstung',
        Meter: 'Meter',
        Piece: 'Stück',
        GiveTask: 'Zuordnung der Aufgabe',
        GiveTaskText: 'Sind Sie sicher, dass Sie jemand anderem eine Aufgabe geben möchten?',
        Company: 'Unternehmen',
        Rejected: 'Abgelehnt',
        UploadFile: 'Datei hochladen',
        Size: 'Größe',
        Download: 'Herunterladen',
        EditNotes: 'Notizen bearbeiten',
        Comments: 'Bemerkungen',
        PauseWork: 'Arbeit unterbrechen',
        ContinueWithWork: 'Weitermachen mit Arbeit',
        Project: 'Projekt',
        TotalTime: 'Gesamtzeit',
        Resize: 'Größe ändern',
        ProjectTemplates: 'Projektvorlagen',
        DeadlineFromStart: 'Frist von Anfang an (Tage)',
        ProjectTemplateTasks: 'Aufgabenvorlagen',
        Template: 'Vorlage',
        Without: 'Ohne',
        TaskIsPaused: 'Aufgabe ist angehalten',
        RemoveTime: 'Zeit entfernen',
        RemoveTimeText: 'Möchten Sie diese Zeit wirklich entfernen?',
        Reason: 'Grund',
        Multiplier: 'Multiplikator',
        ProjectHours: 'Projektstunden der Aufgabe',
        EditWorkType: 'Arbeitstyp bearbeiten',
        EditInvoicing: 'Rechnungsstellung bearbeiten',
        Yes: 'Ja',
        No: 'Nein',
        NonInvoicedPart: 'Nicht in Rechnung gestelltes Teil',
        NonInvoicedTime: 'Nicht in Rechnung gestellte Zeit',
        InvoicingComment: 'Rechnungskommentar',
        SendToConfirm: 'Senden, um zu bestätigen',
        Contacts: 'Kontakte',
        Preview: 'Vorschau',
        OpenPDF: 'Öffnen',
        BranchOffice: 'Niederlassung',
        Contact: 'Kontakt',
        EditContact: 'Kontakt bearbeiten',
        AddContact: 'Kontakt hinzufügen',
        TaskSentForConfirmation: 'Aufgabe zur Bestätigung gesendet!',
        Approve: 'Genehmigen',
        ApproveTask: 'Aufgabe genehmigen',
        TaskApproved: 'Aufgabe erfolgreich genehmigt!',
        Decline: 'Ablehnen',
        DeclineTask: 'Aufgabe ablehnen',
        TaskDeclined: 'Aufgabe erfolgreich abgelehnt!',
        OpenPrintout: 'PDF öffnen',
        PrimaryContact: 'Hauptkontakt',
        BranchOffices: 'Niederlassungen',
        Title: 'Titel',
        PostNumAddr: 'Stadt und Postleitzahl',
        Town: 'Stadt',
        StartWithTransport: 'Beginnen Sie die Reise',
        Passengers: 'Passagiere',
        Destination: 'Ziel',
        FinishTransport: 'Reise beenden',
        TransportHome: 'Heimweg',
        List: 'Liste',
        Settings: 'Einstellungen',
        Holidays: 'Ferien',
        Days: 'Tage',
        Monday: 'Montag',
        Tuesday: 'Dienstag',
        Wednesday: 'Mitwoch',
        Thursday: 'Donnerstag',
        Friday: 'Freitag',
        Saturday: 'Samstag',
        Sunday: 'Sontag',
        BasicSettings: 'Grundeinstellungen',
        MinimalInvoicingUnit: 'Minimale Rechnungseinheit (in Minuten)',
        MinimalWorkTimePerDay: 'Minimale Anzahl von Arbeitsstunden pro Tag',
        WorkDays: 'Arbeitstage',
        Timezone: 'Zeitzone',
        HeadquartersAddress: 'Anschrift der Hauptniederlassung',
        Year: 'Jahr',
        Month: 'Monat',
        Time: 'Zeit',
        RegenerateTimes: 'Zeit wieder generieren',
        TimesPerMonth: 'Stunden pro Monat erforderlich',
        TimesRegenerated: 'Zeiten regeneriert',
        Saved: 'Gespeichert',
        Profile: 'Profil',
        Logout: 'Abmelden',
        TimeOverview: 'Zeitübersicht im laufenden Monat',
        FinishedHours: 'Arbeitsstunden im laufenden Monat',
        HoursNeeded: 'Stunden im laufenden Monat erforderlich',
        Total: 'Gesamt',
        Absence: 'Abwesenheit',
        Work: 'Arbeit',
        Analytics: 'Analytik',
        ResetPass: 'Kennwort ändern',
        SendResetMail: 'Anfrage senden',
        ResetText: 'Mail mit Link und Anleitung wurde an Sie gesendet!',
        PasswordReset: 'Kennwort wurde erfolgreich geändert',
        Reload: "Neu laden",
        MonthlyDifferenceTillNow: 'Monatliche Stundendifferenz bis jetzt',
        TotalDifferenceTillNow: 'Total Stundendifferenz bis jetzt',
        AbsenceRequestsAdding: 'Abwesenheitsanfrage hinzufügen',
        AddAbsence: 'Geplante Abwesenheit hinzufügen',
        AddVacation: 'Urlaub hinzufügen',
        AddSickLeave: 'Krankenstand hinzufügen',
        Statistics: 'Statistiken',
        Vacations: 'Urlaube',
        January: 'Januar',
        February: 'Februar',
        March: 'März',
        April: 'April',
        May: 'Mai',
        June: 'Juni',
        July: 'Juli',
        August: 'August',
        September: 'September',
        October: 'Oktober',
        November: 'November',
        December: 'Dezember',
        VacationsContract: 'Urlaubsvertrag',
        SickLeaveProofs: 'Krankenstand Notizen',
        SickLeave: 'Krankenstand',
        Vacation: 'Urlaub',
        TimeLockDay: 'Tag der Zeitsperre',
        MonthlyDifference: 'Monatliche Differenz',
        Invoicing: 'Fakturierung',
        TasksWaiting: 'Aufgaben warten',
        InvoicesFinished: 'Rechnungen fertig',
        InvoicesWaiting: 'Rechnungen warten',
        CreateInvoicingGroup: 'Gruppe erstellen',
        AddToInvoicingGroup: 'Zur Gruppe hinzufügen',
        NumberOfTasks: 'Anzahl der Aufgaben',
        Date: 'Datum',
        TaskIds: 'Aufgaben-IDs',
        RemoveInvoicingGroup: 'Gruppe entfernen',
        DeniedLetter: 'D',
        DeniedReason: 'Verweigerungsgrund:',
        Id: "ID",
        File: 'Datei',
        Requests: 'Anfragen',
        TransportNames: 'Transportnamen',
        Kilometers: 'Kilometer',
        CountKilometers: 'Kilometer Anzahl ',
        AllowManualUse: 'Verwendung beim manuellen Start zulassen',
        Difference: 'Unterschied',
        Finish: 'Fertig',
        VacationLockDay: 'Urlaubstag am vergangenen Jahr',
        VacationLockMonth: 'Urlaubsentfernungsmonat des vergangenen Jahres',
        Comment: 'Kommentar',
        Adder: 'Hinzugefügt',
        TimeEdits: 'Manuelle Zeitänderungen',
        TravelOrders: 'Reiseaufträge',
        Day: 'Tag',
        Driver: 'Fahrer',
        OpenTasks: 'Offene Aufgaben',
        ClientTimeOverview: 'Kunde-Zeitübersicht',
        LastKilometers: 'Letzte Kilometer',
        GeneratePDF: 'PDF generieren',
        GenerateExcel: 'Excel generieren',
        ProjectOffers: 'Projektangebote',
        ProjectOfferTasks: 'Angebote Aufgaben',
        CreateProjectFromOffer: 'Projekt aus Angebot erstellen',
        SaveAsTemplate: 'Als Vorlage speichern',
        CreateProjectFromTemplate: 'Projekt aus Vorlage erstellen',
        CreateProjectOfferFromTemplate: 'Projektangebot aus Vorlage erstellen',
        Other: 'Andere',
        Offer: 'Angebot',
        Invoice: 'Rechnung',
        Documentation: 'Dokumentation',
        Finished: 'Beendet',
        FinishProjectWithoutHandover: 'Projekt ohne Übergabe beenden',
        StartWithHandover: 'Beginnen Sie mit der Übergabe',
        ConfirmHandover: 'Übergabe bestätigen',
        HandoverDeclined: 'Übergabe erfolgreich abgelehnt',
        HandoverApproved: 'Übergabe erfolgreich genehmigt',
        HandoverNotes: 'Anmerkungen',
        ApproveHandover: 'Übergabe genehmigen',
        DeclineHandover: 'Übergabe ablehnen',
        StopHandover: 'Übergabe stoppen',
        InvoicedProjects: 'Fakturiert',
        FinishNoHandoverPrompt: 'Sind Sie sicher, dass Sie das Projekt beenden möchten? Eine Bearbeitung danach ist nicht mehr möglich!',
        ProjectFinished: 'Projekt abgeschlossen',
        ProjectWaitingForUserConfirm: 'Warten auf Bestätigung des Projektleiters',
        ProjectWaitingForClientConfirm: 'Warten auf Kundenbestätigung',
        FileType: 'Dateityp',
        OfferId: 'Angebots-ID',
        DownloadHandoverPrintout: 'Handover-Ausdruck herunterladen',
        ProjectFinishedWithoutHandover: 'Projekt ohne Übergabe abgeschlossen!',
        Start: 'Start',
        AllProjects: 'Alle',
        OwnProjects: 'Mein',
        OpenProjects: 'Offen',
        FinishedProjects: 'Beendet',
        PausedTasks: 'Pause',
        Commercial: 'Kommerziell',
        Week: 'Woche',
        Calendar: 'Kalender',
        Absences: 'Abwesenheiten',
        CarryTimeOver: 'Übertragen Sie die Zeit auf den nächsten Monat',
        IgnoreMultipliers: 'Multiplikatoren ignorieren',
        ProjectLeader: 'Projektleiter',
        Overviews: 'Übersichten',
        TimeWorked: 'Arbeitszeit',
        PlannedTime: 'Geplante Zeit',
        DateCreated: 'Datum erstellt',
        DateFinished: 'Datum beendet',
        Color: 'Farbe',
        Tag: 'Stichwort',
        Tags: 'Stichworte',
        GlobalTag: 'Globale Stichworte',
        SaveTags: 'Stichworte speichern',
        EditTags: 'Stichworte bearbeiten',
        Notifications: 'Benachrichtigungen',
        SatisfactionWithUs: 'Wie zufrieden sind Sie mit uns?',
        DuplicateSelectedTransport: 'Ausgewählten Transport duplizieren',
        TravelOrderInvalid: 'Reiseauftrag ist ungültig!',
        OpenTravelOrder: 'Öffnen',
        RegenerateTravelOrder: 'Reisebestellung neu generieren',
        BranchOfficeLocationValid: 'Ort gefunden',
        SetVisibleTags: 'Sichtbare Stichworte',
        ExpandColumns: 'Spalten erweitern',
        ClearFilters: 'Filter löschen',
        atVehicles: 'Spezialfahrzeuge',
        PeriodsTable: 'Tabelle der Perioden',
        GenerationFailed: 'Generierung fehlgeschlagen',
        Refueled: 'Betankt',
        RefuelSize: 'Kraftstoffmenge',
        WayPoints: 'Wegpunkte',
        StartGeneration: 'Generierung starten',
        ApprovalTime: 'Genehmigt',
        BusinessTrips: 'Geschäftsreisen',
        CoWorkers: 'Mitarbeiter',
        NotificationStartHour: 'Beginn der Benachrichtigungen (in Stunden)',
        NotificationEndHour: 'Ende der Benachrichtigungen (in Stunden)',
        DashTasksToday: 'Tag',
        DashTasksThisWeek: 'Woche',
        DashTasksThisMonth: 'Monat',
        Dashboard: 'Instrumententafel',
        TasksAdded: 'Hinzugefügt',
        TasksFinished: 'Beendet',
        DashTimeToday: 'Tag',
        DashTimeThisWeek: 'Woche',
        DashTimeThisMonth: 'Monat',
        DashTimeInvoiced: 'Fakturiert',
        DashTimeNonInvoiced: 'Nicht fakturiert',
        DashTimeOnCompany: 'Pro Firma',
        DashTaskNum: 'Alle Aufgaben nach Priorität',
        DashTaskTime: 'Zeit nach Priorität',
        DashTaskNumOwn: 'Meine Aufgaben',
        DashOwnTasksOpen: 'Öffnen',
        DashOwnTasksInConfirmation: 'Zur Bestätigung',
        DashOwnTasksDeadlineToday: 'Frist heute',
        DashOwnTasksDeadlineNext7Days: 'Frist in den nächsten 7 Tagen',
        DashOwnTasksOverDeadline: 'Über die Frist hinaus',
        StealTask: 'Aufgabe stehlen',
        TimeAnalytics: 'Zeitanalyse',
        OnlyProjects: 'Nur Projekte',
        Untagged: 'Ohne Stichworte',
        AnalyticsTotalTime: "Gesamtzeit",
        AnalyticsNonInvoicedTime: 'Nicht in Rechnung gestellte Zeit',
        TimeByUser: 'Zeit nach Benutzer',
        TimeByClient: 'Zeit nach Kunden',
        OnCall: 'Im Dienst',
        CandidateGeneration: 'Kandidatengenerierung',
        BranchOfficePlacement: 'Niederlassung hinzufügen',
        TravelOrderGeneration: 'Generierung von Reiseaufträgen',
        ChangeClient: 'Kunde wechseln',
        Offers: 'Angebote',
        MyOffers: 'Mein',
        AllOffers: 'Alle',
        FinishedOffers: 'Beendet',
        ArchivedOffers: 'Archiviert',
        OffersInMaking: 'In der Arbeit',
        ApprovedOffers: 'Genehmigt',
        OfferManagementUser: 'Angebotsmanager',
        CommercialUser: 'Zugewiesener Kommercialist',
        OffersAdded: 'Hinzugefügt',
        OffersChangeNeeded: 'Änderung ist erforderlich',
        OffersReadyForMaking: 'Bereit zu machen',
        OffersTaken: 'Genommen',
        OffersInWork: 'In Arbeit',
        OffersOfferMade: 'Angebot gemacht',
        OffersSentToClient: 'An den Kunden gesendet',
        OffersApproved: 'Genehmigt',
        OffersOrdered: 'Bestellt',
        OffersFinished: 'Beendet',
        OffersArchived: 'Archiviert',
        UploadOffer: 'Angebot hochladen',
        UnsavedChanges: 'Du hast nicht gespeicherte Änderungen',
        OfferCommercialNotes: 'Kommerzielle Notizen',
        AddOfferCommercialNotes: 'Fügen Sie kommerzielle Notizen hinzu',
        CancelOffer: 'Angebot stornieren',
        TakeOffer: 'Angebot annehmen',
        FinishOffer: 'Angebot beenden',
        OfferType: 'Angebotsart',
        OfferNormal: 'Ohne Projekt',
        AddBackToOffers: 'Hinzufügen zu Angeboten',
        DateAdded: 'Datum hinzugefügt',
        LastChange: 'Letzte Änderung',
        Meetings: 'Treffen',
        MyMeetings: 'Mein',
        PlannedMeetings: 'Geplant',
        FinishedMeetings: 'Beendet',
        OpenTask: 'Aufgabe öffnen',
        OpenOffer: 'Angebot öffnen',
        OfferTimelineShort0: 'Vorbereiten',
        OfferTimelineLong0: 'Angebotsanfrage wird vorbereitet',
        OfferTimelineShort1: 'Änderung erforderlich',
        OfferTimelineLong1: 'Eine Angebotsänderung wurde beantragt',
        OfferTimelineShort2: 'Anfrage fertig',
        OfferTimelineLong2: 'Die Angebotsanfrage ist fertig und wartet darauf, vom Werbetreibenden angenommen zu werden',
        OfferTimelineShort3: 'Anfrage nehmen',
        OfferTimelineLong3: 'Die Angebotsanfrage wurde vom Kommerzialist angenommen',
        OfferTimelineShort4: 'In der Herstellung',
        OfferTimelineLong4: 'Angebot wird gemacht',
        OfferTimelineShort5: 'Angebot fertig',
        OfferTimelineLong5: 'Das angeforderte Angebot ist beendet',
        OfferTimelineShort6: 'An den Kunden gesendet',
        OfferTimelineLong6: 'Das Angebot wurde an den Kunden gesendet.',
        OfferTimelineShort7: 'Genehmigt',
        OfferTimelineLong7: 'Der Kunde hat das Angebot genehmigt',
        OfferTimelineShort8: 'Bestellt',
        OfferTimelineLong8: 'Material aus dem Angebot wurde bestellt',
        OfferTimelineShort9: 'Beendet',
        OfferTimelineLong9: 'Angebot ist beendet',
        OfferTimelineShort10: 'Abgelehnt',
        OfferTimelineLong10: 'Angebot wurde abgelehnt',
        OfferTimeline: 'Angebot Zeitliste',
        ApproveMeeting: 'Genehmigen',
        MeetingApproved: 'Ihre Zustimmung war erfolgreich!',
        DeclineMeeting: 'Ablehnen',
        MeetingDeclined: 'Besprechungsnotizen wurden erfolgreich abgelehnt!',
        MeetingConfirmed: 'Besprechung bestätigt',
        OpenMeetingPrintout: 'Ausdruck öffnen',
        Services: 'Dienstleistungen',
        KnowledgeBase: 'Wissensbasis',
        DaysLeft: 'Tage übrig',
        ISOWiki: 'ISO',
        Active: 'Aktiv'
    },
    hr: {
        Tasks: 'Zadaci',
        Users: 'Korisnici',
        OwnTasks: 'Moji',
        AllTasks: 'Vsi',
        UnassignedTasks: 'Nedodjeljeni',
        Clients: 'Klijenti',
        Groups: 'Skupine',
        UserTypes: 'Vrsta korisnika',
        Vehicles: 'Vozila',
        WorkTypes: 'Tipovi posla',
        Transport: 'Put',
        TransportTypes: 'Tipovi puta',
        Projects: 'Projekti',
        ClosedTasks: 'Završeni zadaci',
        Login: 'Prijava',
        LoginText: 'Dobrodošao nazad, prijavi se u svoj račun.',
        Password: 'Lozinka',
        RememberMe: 'Zapamti me',
        ForgotPassword: 'Zaboravljeno geslo?',
        TaskTitle: 'Naziv',
        Status: 'Stanje',
        Priority: 'Prioriteta',
        Deadline: 'Rok',
        Added: 'Dodano',
        AssignedUser: 'Dodjeljen',
        Client: 'Klijent',
        Description: 'Opis',
        Edit: 'Uredi',
        ClientData: 'Podaci o stranki',
        Name: 'Ime',
        Address: 'Naslov',
        Country: 'Država',
        AssignedUsers: 'Dodjeljen',
        Add: 'Dodaj',
        Times: 'Vrijeme',
        Material: 'Materijal',
        Files: 'Datoteke',
        Chat: 'Razgovor',
        User: 'Korisnik',
        StartTime: 'Početno vrijeme',
        EndTime: 'Završeno vrijeme',
        WorkType: 'Vrsta posla',
        TypeMessage: 'Napiši poruku',
        Notes: 'Zapisci',
        AddNotes: 'Dodaj zapisak',
        EditTime: 'Uredi vrijeme',
        Delete: 'Obriši',
        Change: 'Promjeni',
        Save: 'Spremi',
        StartPoint: 'Početna točka',
        EndPoint: 'Završna točka',
        Vehicle: 'Vozilo',
        TransportType: 'Vrsta transporta',
        EditTransport: 'Uredi put',
        Distance: 'Udaljenost',
        Unit: 'Jedinica',
        Quantity: 'Količina',
        EditMaterial: 'Uredi materijal',
        StartKilometers: 'Početni kilometri',
        EndKilometers: 'Završni kilometri',
        StartWithWork: 'Počni sa radom',
        StopWithWork: 'Završi sa radom',
        AdditionalNotes: 'Dodatni zapisci',
        TakeTask: 'Preuzmi zadatak',
        Unassigned: 'Nedodjeljeni',
        Open: 'Otvori',
        InProgress: 'U radu',
        Waiting: 'Čekanje',
        SentForConfirmation: 'U potrvđivanju',
        Confirmed: "Potrvđen",
        Invoiced: "Fakturiran",
        VATNumber: "Porezni broj",
        Price: 'Cijena',
        Email: 'Email',
        PhoneNumber: 'Broj telefona',
        ContractHours: 'Ugovoreni sati',
        Type: 'Vrsta',
        Registration: 'Registracija',
        Roles: 'Skupine korisnika',
        LName: 'Prezime',
        Role: 'Uloga',
        UserType: 'Vrsta korisnika',
        Data: 'Podaci',
        Theme: 'Tema',
        ChangeTheme: 'Promjena teme',
        Dark: 'Tamna',
        Light: 'Svijetla',
        ChangePassword: 'Promjena lozinke',
        EnableTOTP: "2FA aktivacija",
        AuthenticatorCode: "Kod iz 2FA aplikacije",
        TOTPEnabled: "2FA aktivan",
        OldPass: 'Stara lozinka',
        NewPass: 'Nova lozinka',
        HourNumber: 'Broj sati',
        VacationDays: 'Godišnji odmor',
        PlannedAbsence: 'Najavljena odsutnost',
        SickLeaves: 'Bolovanje',
        SupportEquipment: 'Pomočna oprema',
        Meter: 'Meter',
        Piece: 'Komad',
        GiveTask: 'Dodaj zadatak',
        GiveTaskText: 'Da li si siguran da želiš dodati zadatak nekome drugome?',
        Company: 'Tvrtka',
        Rejected: 'Odbijeno',
        UploadFile: 'Učitaj datoteku',
        Size: 'Veličina',
        Download: 'Preuzmi',
        EditNotes: 'Uredi zapise',
        Comments: 'Komentari',
        PauseWork: 'Pauziraj',
        ContinueWithWork: 'Nastavi sa radom',
        Project: 'Projekt',
        TotalTime: 'Ukupno vrijeme0',
        Resize: 'Proširi',
        ProjectTemplates: 'Prijedlozi za projekte',
        DeadlineFromStart: 'Rok od početka(u danima)',
        ProjectTemplateTasks: 'Prijedlozi zadataka projekta',
        Template: 'Prijedlog',
        Without: 'Bez',
        TaskIsPaused: 'Zadatak je na čekanju',
        RemoveTime: 'Izbriši vrijeme',
        RemoveTimeText: 'Da li si siguran da želiš izbrisati vrijeme?',
        Reason: 'Razlog',
        Multiplier: 'Faktor',
        ProjectHours: 'Projektni sati zadatka',
        EditWorkType: 'Uredi tip posla',
        EditInvoicing: 'Uredi fakturu',
        Yes: 'Da',
        No: 'Ne',
        NonInvoicedPart: 'Nefakturiran dio',
        NonInvoicedTime: 'Nefakturiran čas (v urah)',
        InvoicingComment: 'Komentar za fakturiranje',
        SendToConfirm: 'Pošalji u potvrđivanje',
        Contacts: 'Kontakti',
        Preview: 'Predpregled',
        OpenPDF: 'Otvori',
        BranchOffice: 'Ured',
        Contact: 'Kontaktna osoba',
        EditContact: 'Uredi kontakt',
        AddContact: 'Dodaj kontakt',
        TaskSentForConfirmation: 'Pošalji zadatak u potvrđivanje',
        Approve: 'Potrvdi',
        ApproveTask: 'Potvrdi zadatak',
        TaskApproved: 'Zadatak je uspješno potvrđen!',
        Decline: 'Odbij',
        DeclineTask: 'Odbij zadatak',
        TaskDeclined: 'Zadatak je uspješno odbijen!',
        OpenPrintout: 'Otvori zadatak',
        PrimaryContact: 'Primarni kontakt',
        BranchOffices: 'Poslovnice',
        Title: 'Naslov',
        PostNumAddr: 'Poštanski broj ',
        Town: 'Grad',
        StartWithTransport: 'Započni sa putom',
        Passengers: 'Putnici',
        Destination: 'Destinacija',
        FinishTransport: 'Završi put',
        TransportHome: 'Put do kuće',
        List: 'Lista',
        Settings: 'Postavke',
        Holidays: 'Praznici',
        Days: 'Dani',
        Monday: 'Ponedjeljak',
        Tuesday: 'Utorak',
        Wednesday: 'Srijeda',
        Thursday: 'Četvrtak',
        Friday: 'Petak',
        Saturday: 'Subota',
        Sunday: 'Nedjelja',
        BasicSettings: 'Osnovne postavke',
        MinimalInvoicingUnit: 'Minimalna obračunska jedinica(u minutama)',
        MinimalWorkTimePerDay: 'Minimalan broj radnih sati na dan',
        WorkDays: 'Delovni dnevi',
        Timezone: 'Vremenski pojas',
        HeadquartersAddress: 'Naslov primarne tvrtke',
        Year: 'Godina',
        Month: 'Mjesec',
        Time: 'Vrijeme',
        RegenerateTimes: 'Ponovno generiraj vrijeme',
        TimesPerMonth: 'Potrebni odrađeni sati po mjesecu',
        TimesRegenerated: 'Vrijeme ponovno generirano',
        Saved: 'Spremljeno',
        Profile: 'Profil',
        Logout: 'Odjava',
        TimeOverview: 'Pregled vremena u tekućem mjesecu',
        FinishedHours: 'Odrađeni sati u tekućem mjesecu',
        HoursNeeded: 'Potrebno vrijeme',
        Total: 'Ukupno',
        Absence: 'Odsutnost',
        Work: 'Posao',
        Analytics: 'Analiza',
        ResetPass: 'Promjeni lozinku',
        SendResetMail: 'Pošalji zahtjev',
        ResetText: 'Mail sa linkom za promjenu lozinke je poslan!',
        PasswordReset: 'Lozinka je uspješno promjenjena',
        Reload: "Osvježi",
        MonthlyDifferenceTillNow: 'Mjesečna razlika sati do sada',
        TotalDifferenceTillNow: 'Ukupna razlika sati do sada',
        AbsenceRequestsAdding: 'Zahtjevi za odsutnost',
        AddAbsence: 'Dodaj odsutnost',
        AddVacation: 'Dodaj godišnji',
        AddSickLeave: 'Dodaj bolovanje',
        Statistics: 'Statistika',
        Vacations: 'Godišnji odmor',
        January: 'Siječanj',
        February: 'Veljača',
        March: 'Ožujak',
        April: 'Travanj',
        May: 'Svibanj',
        June: 'Lipanj',
        July: 'Srpanj',
        August: 'Kolovoz',
        September: 'Rujan',
        October: 'Listopad',
        November: 'Studeni',
        December: 'Prosinac',
        VacationsContract: 'Odluka o godišnjem',
        SickLeaveProofs: 'Potrvde o bolovanju',
        SickLeave: 'Bolovanje',
        Vacation: 'Godišnji',
        TimeLockDay: 'Dan završetka',
        MonthlyDifference: 'Mjesečna razlika',
        Invoicing: 'Fakturiranje',
        TasksWaiting: 'Zadatak na čekanju!',
        InvoicesFinished: 'Završene fakture',
        InvoicesWaiting: 'Fakture na čekanju',
        CreateInvoicingGroup: 'Dodaj skupinu',
        AddToInvoicingGroup: 'Dodaj u skupinu',
        NumberOfTasks: 'Broj zadataka',
        Date: 'Datum',
        TaskIds: 'ID zadatka',
        RemoveInvoicingGroup: 'Obriši skupinu',
        DeniedLetter: 'Z',
        DeniedReason: 'Razlog prekida:',
        Id: "ID",
        File: 'Datoteka',
        Requests: 'Zahtjev',
        TransportNames: 'Ime transporta',
        Kilometers: 'Kilometri',
        CountKilometers: 'Izračunaj kilometre',
        AllowManualUse: 'Dozvoli upotrebu',
        Difference: 'Razlika',
        Finish: 'Završi',
        VacationLockDay: 'Dan otkazivanja prošlogodišnjeg godišnjeg',
        VacationLockMonth: 'Mjesec otkazivanja prošlogodišnjeg godišnjeg',
        Comment: 'Komentar',
        Adder: 'Dodao',
        TimeEdits: 'Vrijeme promjene',
        TravelOrders: 'Putni nalog',
        Day: 'Dan',
        Driver: 'Vozač',
        OpenTasks: 'Otvoreni zadaci',
        ClientTimeOverview: 'Pregled po klijentu',
        LastKilometers: 'Zadnji kilometri',
        GeneratePDF: 'Generiraj PDF',
        GenerateExcel: 'Generiraj excel',
        ProjectOffers: 'Priprema ponude',
        ProjectOfferTasks: 'Ponude zadataka',
        CreateProjectFromOffer: 'Napravi ponudu za zadatak',
        SaveAsTemplate: 'Spremi kao pretpregled',
        CreateProjectFromTemplate: 'Kreiraj projekt sa pretpregledom',
        CreateProjectOfferFromTemplate: 'Kreiraj ponudu sa pretpregled',
        Other: 'Ostalo',
        Offer: 'Ponuda',
        Invoice: 'Faktura',
        Documentation: 'Dokumentacija',
        Finished: 'Završeno',
        FinishProjectWithoutHandover: 'Završeni projekt bez primopredaje',
        StartWithHandover: 'Započni s primopredajom',
        ConfirmHandover: 'Potvrdi zapisnik',
        HandoverDeclined: 'Zapisnik uspješno odbijen!',
        HandoverApproved: 'Zapisnik uspješno potvrđen',
        HandoverNotes: 'Podsjetnik',
        ApproveHandover: 'Potrvdi primopredaju zapisnika',
        DeclineHandover: 'Odbij primopredaju zapisnika',
        StopHandover: 'Zaustavi primopredaju zapisnika',
        InvoicedProjects: 'Fakturirani projekti',
        FinishNoHandoverPrompt: 'Jeste li sigurno da želite završiti projekt? Naknadne promijene nisu moguće',
        ProjectFinished: 'Projekt završen',
        ProjectWaitingForUserConfirm: 'Čekanje potvrde korisnika',
        ProjectWaitingForClientConfirm: 'Čekanje potvrde klijenta',
        FileType: 'Tip datoteke',
        OfferId: 'ID ponude',
        DownloadHandoverPrintout: 'Preuzmi ispis primopredaje',
        ProjectFinishedWithoutHandover: 'Projekt završen bez primopredaje',
        Start: 'Započni',
        AllProjects: 'Svi projekti',
        OwnProjects: 'Vlastiti projekti',
        OpenProjects: 'Otvoreni projekti',
        FinishedProjects: 'Završeni projekti',
        PausedTasks: 'Pauzirani zadaci',
        Commercial: 'Komerijala',
        Week: 'Tjedan',
        Calendar: 'Kalendar',
        Absences: 'Odsustva',
        CarryTimeOver: 'Prenesi vrijeme na sljedeći mjesec',
        IgnoreMultipliers: 'Ignoriraj faktoree',
        ProjectLeader: 'Voditelj projekta',
        Overviews: 'Pregledi',
        TimeWorked: 'Odrađeni vrijeme',
        PlannedTime: 'Planirano vrijeme',
        DateCreated: 'Datum kreiranja',
        DateFinished: 'Datum završetka',
        Color: 'Boja',
        Tag: 'Oznaka',
        Tags: 'Oznake',
        GlobalTag: 'Globalne oznake',
        SaveTags: 'Spremi oznake',
        EditTags: 'Promijeni oznake',
        Notifications: 'Obavijesti',
        SatisfactionWithUs: 'Kako ste zadovoljni sa nama?',
        DuplicateSelectedTransport: 'Dupliciraj odabrani transport',
        TravelOrderInvalid: 'Putni nalog nije valjan!',
        OpenTravelOrder: 'Otvori putni nalog',
        RegenerateTravelOrder: 'Ponovo generiraj putni nalog',
        BranchOfficeLocationValid: 'Lokacija pronađena',
        SetVisibleTags: 'Vidljive oznake',
        ExpandColumns: 'Proširi stupce',
        ClearFilters: 'Poništi filtere',
        atVehicles: 'Specijalna vozila',
        PeriodsTable: 'Tabela perioda',
        GenerationFailed: 'Generiranje neuspješno',
        Refueled: 'Napunjeno gorivom',
        RefuelSize: 'Količina goriva',
        WayPoints: 'Oznake',
        StartGeneration: 'Započni generiranje',
        ApprovalTime: 'Potvrđeno',
        BusinessTrips: 'Poslovni putovi',
        CoWorkers: 'Kolege',
        NotificationStartHour: 'Početak obavijesti (u satima)',
        NotificationEndHour: 'Kraj obavijesti (u satima)',
        DashTasksToday: 'Dan',
        DashTasksThisWeek: 'Tjedan',
        DashTasksThisMonth: 'Mjesec',
        Dashboard: 'Dashboard',
        TasksAdded: 'Dodani',
        TasksFinished: 'Završeni',
        DashTimeToday: 'Dan',
        DashTimeThisWeek: 'Tjedan',
        DashTimeThisMonth: 'Mjesec',
        DashTimeInvoiced: 'Fakturirano',
        DashTimeNonInvoiced: 'Nefakturirano',
        DashTimeOnCompany: 'Na firmu',
        DashTaskNum: 'Statistika svih naloga po prioritetu',
        DashTaskTime: 'Statistika svih naloga po vremenu',
        DashTaskNumOwn: 'Statistika mojih naloga',
        DashOwnTasksOpen: 'Otvoreni',
        DashOwnTasksInConfirmation: 'Čeka na potvrdu',
        DashOwnTasksDeadlineToday: 'Rok danas',
        DashOwnTasksDeadlineNext7Days: 'Rok u sljedećih 7 dana',
        DashOwnTasksOverDeadline: 'Rok je premašen',
        StealTask: 'Preuzmi nalog',
        TimeAnalytics: 'Analitika vremena',
        OnlyProjects: 'Samo projekti',
        Untagged: 'Bez oznake',
        AnalyticsTotalTime: 'Ukupno vrijeme',
        AnalyticsNonInvoicedTime: 'Nefakturirano vrijeme',
        TimeByUser: 'Vrijeme po korisniku',
        TimeByClient: 'Vrijeme po klijentu',
        OnCall: 'Dežurstvo',
        CandidateGeneration: 'Kreiranje kandidata',
        BranchOfficePlacement: 'Mjesto poslovnice',
        TravelOrderGeneration: 'Kreiranje putnog naloga',
        ChangeClient: 'Promjeni klijenta',
        Offers: 'Ponude',
        MyOffers: 'Moje',
        AllOffers: 'Sve',
        FinishedOffers: 'Završene',
        ArchivedOffers: 'Arhivirane',
        OffersInMaking: 'U izradi',
        ApprovedOffers: 'Odobrene ponude',
        OfferManagementUser: 'Voditelj ponude',
        CommercialUser: 'Dodjeljen komercijalist',
        OffersAdded: 'Dodano',
        OffersChangeNeeded: 'Potrebna izmjena',
        OffersReadyForMaking: 'Spremno za izradu',
        OffersTaken: 'Preuzete',
        OffersInWork: 'U izradi',
        OffersOfferMade: 'Ponuda izrađena',
        OffersSentToClient: 'Ponuda poslana klijentu',
        OffersApproved: 'Odobrena',
        OffersOrdered: 'Naručena',
        OffersFinished: 'Završena',
        OffersArchived: 'Arhivirana',
        UploadOffer: 'Učitaj ponudu',
        UnsavedChanges: 'Imate nespremljene promjene',
        OfferCommercialNotes: 'Komercijalni zapisi',
        AddOfferCommercialNotes: 'Dodaj komercijalne zapise',
        CancelOffer: 'Otkaži ponudu',
        TakeOffer: 'Preuzmi ponudu',
        FinishOffer: 'Dovrši ponudu',
        OfferType: 'Vrsta ponude',
        OfferNormal: 'Bez projekta',
        AddBackToOffers: 'Dodaj natrag u ponude',
        DateAdded: 'Datum dodavanja',
        LastChange: 'Zadnja promjena',
        Meetings: 'Sastanci',
        MyMeetings: 'Moji',
        PlannedMeetings: 'Planirani',
        FinishedMeetings: 'Završeni',
        OpenTask: 'Otvoreni zadaci',
        OpenOffer: 'Otvori ponudu',
        OfferTimelineShort0: 'U pripremanju',
        OfferTimelineLong0: 'Zahtjev za ponudu je u pripremanju',
        OfferTimelineShort1: 'Potrebne promijene',
        OfferTimelineLong1: 'Zatražena je promijena u ponudi',
        OfferTimelineShort2: 'Zahtjev spreman',
        OfferTimelineLong2: 'Zahtjev za ponudu je spreman i čeka na preuzimanje od strane komercijalista',
        OfferTimelineShort3: 'Zahtjev preuzet',
        OfferTimelineLong3: 'Zahtjev je preuzet od strane komercijalista',
        OfferTimelineShort4: 'U izradi',
        OfferTimelineLong4: 'Ponuda je u izradi',
        OfferTimelineShort5: 'Ponuda spremna',
        OfferTimelineLong5: 'Ponuda je izrađena',
        OfferTimelineShort6: 'Poslano stranci',
        OfferTimelineLong6: 'Ponuda poslana stranci te se čeka na odgovor',
        OfferTimelineShort7: 'Potvrđena',
        OfferTimelineLong7: 'Ponuda prihvaćena od strane stranke',
        OfferTimelineShort8: 'Naručena',
        OfferTimelineLong8: 'Materijal iz ponude je naručen',
        OfferTimelineShort9: 'Zaključena',
        OfferTimelineLong9: 'Ponuda je zaključena',
        OfferTimelineShort10: 'Odbijena',
        OfferTimelineLong10: 'Ponuda je odbijena',
        OfferTimeline: 'Vremenska crta ponude',
        ApproveMeeting: 'Potvrdi sastanak',
        MeetingApproved: 'Vaša potvrda je uspješna!',
        DeclineMeeting: 'Odbij',
        MeetingDeclined: 'Zapisnik sa sastanka uspješno odbijeni!',
        MeetingConfirmed: 'Sastanak potvrđen',
        OpenMeetingPrintout: 'Otvori zapisnik',
        Services: 'Servisi',
        KnowledgeBase: 'Baza znanja',
        DaysLeft: 'Preostali dani',
        ParentalLeaves: 'Roditeljski dopusti',
        AddParentalLeave: 'Dodaj roditeljski dopust',
        ParentalLeave: 'Roditeljski dopust',
        RegistrationTerminals: 'Terminal za registraciju',
        LinkCopied: 'Kopirana poveznica',
        RFIDErrSelectionOpen: 'Greška prilikom otvaranja RFID',
        RegistrationTerminalPIN: 'Lozinka za registracijski terminal',
        RegistrationTerminalRFIDId: 'Identifikacijski broj RFID ',
        Cancel: 'Prekid',
        TerminalEnter: 'Enter',
        TerminalPause: 'Pauza',
        TerminalLeave: 'izađi',
        TerminalEnterSuccessful: 'Uspješan ulazak u terminal',
        TerminalEnterFailed: 'Neuspješan ulaz',
        TerminalPauseSuccessful: 'Uspješno pauziranje',
        TerminalPauseFailed: 'Neuspješno pauziranje',
        TerminalLeaveSuccessful: 'Izlazak iz terminala uspješan!',
        TerminalLeaveFailed: 'Neuspješan izlazak iz terminala!',
        RegistrationTerminalTask: 'Zadatak',
        RegistrationTerminalClient: 'Klijent',
        RegistrationTerminalBranchOffice: 'Glavni ured',
        RegistrationTerminalWorkType: 'Tip posla',
        ISOWiki: 'ISO',
        Active: 'Aktivan'
    },
}
